{
  "agreements": {
    "defaultTitle": "Agreement",
    "loading": "Loading agreement…",
    "loadError": "Could not load the agreement.",
    "checkbox": "I have read and accept the terms.",
    "confirm": "Accept and continue",
    "submitting": "Submitting…"
  },
  "seedance": {
    "videoConsentIntro": "Video generation will use Seedance assets for: {{names}}. Confirm the agreement to continue generation.",
    "videoConsentCheckFailed": "Could not check the Seedance agreement before video generation.",
    "registrationConsentIntro": "Asset registration uploads the character or outfit reference to the Seedance asset library. Confirm the agreement to continue."
  },
  "canvas": {
    "headTitle": "Canvas",
    "title": "Canvas",
    "empty": {
      "title": "Create your first generation",
      "hint": "Pick a model, add a prompt and press Generate.",
      "allTitle": "No generations",
      "allHint": "There are no generations on the canvases in this project yet."
    },
    "feed": {
      "loadingMore": "Loading…",
      "end": "All generations loaded"
    },
    "panel": {
      "promptPlaceholder": "Describe what to generate…",
      "image": "Image",
      "video": "Video",
      "assistant": "Assistant",
      "errors": "Errors",
      "errorsWithCount": "Errors · {{count}}",
      "model": "Model",
      "aspectRatio": "Aspect ratio",
      "duration": "Duration",
      "durationSec": "{{count}} sec",
      "attachReference": "Attach reference",
      "referencesTitle": "References",
      "removeReference": "Remove reference",
      "pickCharacter": "Characters",
      "pickLocation": "Locations",
      "pickProp": "Props",
      "pickPrimitive": "Objects",
      "pickerEmpty": "Nothing to pick yet",
      "insertMention": "Insert mention into prompt",
      "previewReference": "Open reference preview",
      "dropFilesHint": "Drop files here",
      "dropFilesReject": "Unsupported file type",
      "useProjectStyles": "Use project styles",
      "useProjectStylesDisabled": "Project styles are turned off in settings",
      "useProjectStylesEmpty": "No project styles configured",
      "viewStyles": "View styles",
      "generate": "Generate",
      "generating": "Generating…",
      "uploading": "Uploading…",
      "libraryLoading": "Loading library…",
      "libraryRetry": "Try again",
      "quality": "Quality",
      "generateAudio": "Generate audio",
      "draft": "Draft",
      "generateAudioEnabledHint": "Generate audio turned on",
      "generationRef": "Gen {{id}}",
      "collapse": "Collapse panel",
      "expand": "Expand panel",
      "libraryDeleted": "Reference removed from library",
      "videoConsiderScaleHintLink": "scale sheet"
    },
    "status": {
      "queued": "Queued",
      "processing": "Processing",
      "completed": "Done",
      "failed": "Failed"
    },
    "tile": {
      "failed": "Generation failed"
    },
    "errorsList": {
      "empty": "No failed generations"
    },
    "modal": {
      "title": "Generation",
      "generationId": "Generation ID",
      "board": "Canvas",
      "quality": "Quality mark",
      "prompt": "Prompt",
      "model": "Model",
      "aspectRatio": "Aspect ratio",
      "resolution": "Resolution",
      "duration": "Duration",
      "params": "Parameters",
      "references": "References",
      "error": "Error",
      "projectStyles": "Project styles included",
      "regenerate": "Regenerate",
      "openInEditor": "Open in editor",
      "retryProviderTransient": "Generate again",
      "retryProviderTransientShort": "Again",
      "retryQueued": "Generation queued.",
      "useAsReference": "Use as reference",
      "copyPrompt": "Copy prompt",
      "promptCopied": "Prompt copied",
      "save": "Save to project",
      "download": "Download original",
      "restoreTrim": "Restore original",
      "restoreTrimHint": "Clear trim and show the full original clip",
      "trimSaveFailed": "Could not save trim",
      "copyImage": "Copy",
      "imageCopied": "Image copied to clipboard",
      "copyFailed": "Could not copy image",
      "close": "Close",
      "previous": "Previous",
      "next": "Next",
      "noContent": "No content",
      "savedTo": "Saved to project",
      "savedToOpen": "Open {{label}}"
    },
    "save": {
      "title": "Save to project",
      "target": "Save as",
      "asCharacter": "New character",
      "asLocation": "New location",
      "asShotStoryboard": "Shot reference frame",
      "asShotShootingBoard": "Shot storyboard",
      "asShotVideo": "Shot video",
      "name": "Name",
      "namePlaceholder": "Name…",
      "characterNamePlaceholder": "Hero name",
      "locationNamePlaceholder": "Location name",
      "selectShot": "Select shot",
      "shotNumber": "Shot {{scene}}.{{shot}}",
      "shotLabel": "{{episode}}.{{scene}}.{{shot}}",
      "submit": "Save",
      "saved": "Saved to project",
      "shotCreated": "Shot created",
      "createShot": "Create new shot",
      "pickShot": "Pick a shot",
      "hero": "Character",
      "location": "Location",
      "prop": "Prop",
      "createCharacter": "Create new character",
      "createLocation": "Create new location",
      "createProp": "Create new prop",
      "emptyCharacters": "No characters in this project yet.",
      "emptyLocations": "No locations in this project yet.",
      "emptyProps": "No props in this project yet.",
      "slotPortrait": "Portrait",
      "slotReference": "Reference sheet",
      "slotFrontView": "Front view",
      "slotStepTitle": "Where to save",
      "slotStepHint": "Choose portrait/front view or the reference sheet. Preview shows this generation.",
      "next": "Next",
      "selectCharacter": "Character",
      "selectLocation": "Location",
      "existingCharacter": "Search characters…",
      "existingLocation": "Search locations…",
      "propNamePlaceholder": "Prop name",
      "videoOnly": "Only generated videos can be saved as a shot video.",
      "noShots": "No shots in the project yet.",
      "pickProject": "Project",
      "pickProjectHint": "Pick which project to save this generation into.",
      "noProjects": "No projects you can save into. You need content-edit access.",
      "loadingCatalogs": "Loading project catalog…"
    },
    "referencesModal": {
      "title": "Add reference",
      "subtitle": "Pick from the project or upload files.",
      "upload": "Upload file",
      "moreTabsAria": "More reference sources",
      "pickFromLibrary": "Pick from library",
      "sketch": "Sketch",
      "attach": "Attach"
    },
    "sketch": {
      "title": "Sketch",
      "useAsReference": "Use as reference",
      "discardTitle": "Discard changes?",
      "discardMessage": "Unsaved strokes or edits will be lost.",
      "discardConfirm": "Discard",
      "toolSelect": "Select",
      "toolPen": "Pen",
      "toolZoomIn": "Zoom in",
      "toolZoomOut": "Zoom out",
      "toolPan": "Pan",
      "toolEraser": "Eraser",
      "toolObjects": "Objects",
      "shapeRect": "Rectangle",
      "shapeEllipse": "Circle",
      "toolArrow": "Arrow",
      "toolArrowLabel": "Arrow with label",
      "toolText": "Text",
      "penMarker": "Marker",
      "penHighlighter": "Highlighter",
      "penColor": "Color",
      "weight": "Weight",
      "transparency": "Transparency",
      "undo": "Undo",
      "redo": "Redo",
      "delete": "Delete",
      "layoutFill": "Fill area",
      "layoutLabel": "Canvas size",
      "aiHeading": "Correction",
      "resizePanelAria": "Resize correction panel",
      "promptPlaceholder": "Describe the edit…",
      "applyAi": "Correct",
      "applyingAi": "Correction",
      "correctionShort": "Correction",
      "quickPrompts": {
        "removeCircled": "Remove the circled object",
        "removeBackground": "Remove the background",
        "remakeArrowTarget": "Remake the object the arrow points to"
      },
      "correctionUnavailable": "Correction is not configured",
      "editFailed": "Could not edit image",
      "fetchImageFailed": "Could not load image ({{status}})",
      "editCancelled": "Correction cancelled",
      "confirmFailed": "Could not use image as reference",
      "editInSketch": "Edit in sketch",
      "confirmSave": "Save",
      "saveAsViewpoint": "Save as viewpoint",
      "confirmSaveLibrary": "Save to library",
      "savedToLibrary": "Saved to library",
      "textStyle": "Style",
      "textSize": "Size",
      "textFill": "Color",
      "defaultFileName": "sketch-{{number}}",
      "renameTitleHint": "Click to rename file",
      "startEditing": "Edit",
      "viewActionsMenu": "More actions",
      "zoomFit": "Fit",
      "zoomPercent": "{{percent}}%",
      "zoomMenuAria": "Zoom"
    },
    "styles": {
      "title": "Project styles",
      "subtitle": "Read-only. Edit styles in project settings.",
      "visualStyle": "Visual style",
      "genre": "Genre",
      "tone": "Tone",
      "empty": "No project styles configured.",
      "disabledHint": "Project styles are turned off in settings."
    },
    "errors": {
      "createFailed": "Could not start generation",
      "uploadFailed": "Could not upload reference",
      "uploadCancelFailed": "Could not cancel the upload",
      "fileTooLarge": "File is too large (max {{max}} MB)",
      "videoDurationInvalid": "Video must be between {{min}} and {{max}} seconds",
      "videoDurationInvalidNamed": "Wrong duration ({{min}}–{{max}}s): {{names}}",
      "videoDurationUnreadable": "Could not determine video duration",
      "videoDurationTotalInvalid": "Combined video references must be at most {{max}} s (now {{total}} s)",
      "audioDurationInvalid": "Audio must be between {{min}} and {{max}} seconds",
      "audioDurationInvalidNamed": "Wrong audio duration ({{min}}–{{max}}s): {{names}}",
      "audioDurationUnreadable": "Could not determine audio duration",
      "audioDurationTotalInvalid": "Combined audio references must be at most {{max}} s (now {{total}} s)",
      "audioRefsUnsupported": "This video model does not support audio references",
      "audioRefsLimit": "You can add at most {{max}} audio references",
      "saveFailed": "Could not save",
      "deleteFailed": "Could not delete",
      "qualitySaveFailed": "Could not save quality mark",
      "loadFailed": "Could not load generations",
      "noModel": "Select a model",
      "noPrompt": "Add a prompt",
      "alreadyGenerating": "Wait for the current generation to finish"
    },
    "sidebar": {
      "renameEdit": "Rename board",
      "deleteBoard": "Delete board",
      "deleteConfirm": "Delete board \"{{title}}\"?",
      "deleteConfirmWithUploads": "Delete board \"{{title}}\"?\nUploaded files ({{count}}) will be removed — they will disappear from the Library too. Files used elsewhere are kept.",
      "deleted": "Board deleted"
    },
    "switcher": {
      "all": "All",
      "create": "Create new",
      "aria": "Choose canvas",
      "renameTitle": "Rename canvas",
      "renameName": "Name"
    },
    "actions": {
      "delete": "Delete",
      "deleteConfirm": "Delete this generation?",
      "deleted": "Generation deleted"
    }
  },
  "frameLibrary": {
    "loadFailed": "Failed to load frames.",
    "firstFrame": "First frame",
    "lastFrame": "Last frame",
    "capturesWithoutVersion": "Screenshots without a version"
  },
  "library": {
    "headTitle": "Library",
    "title": "Library",
    "loadFailed": "Failed to load data.",
    "retry": "Retry",
    "sections": {
      "shots": "Shots",
      "canvas": "Canvas",
      "flow": "Flow",
      "sketches": "Sketches",
      "uploads": "Uploads",
      "characters": "Characters",
      "locations": "Locations",
      "props": "Props",
      "scenes_3d": "3D Scenes"
    },
    "entity": {
      "empty": "This entity has no media yet.",
      "group": {
        "outfit": "Outfit",
        "variant": "Variant",
        "state": "State",
        "viewpoints": "Viewpoints",
        "portrait": "Portraits",
        "expressionSheet": "Expressions",
        "gaitReference": "Gait",
        "actionBeat": "Action beats",
        "voiceDemo": "Voice",
        "referenceVersions": "Reference versions",
        "characterSheetVersions": "Character sheet versions",
        "emotionSheetVersions": "Emotion sheet versions",
        "scalePoseVersions": "Scale and pose versions",
        "frontViewVersions": "Front view versions",
        "references": "References",
        "locationPrevizes": "3D Scenes",
        "wallScene": "3D scene",
        "scene3dViewpoints": "Viewpoints"
      },
      "item": {
        "reference": "Reference",
        "characterSheet": "Character sheet",
        "emotionSheet": "Emotion sheet",
        "scalePose": "Scale and pose",
        "frontView": "Front view",
        "viewpoint": "Viewpoint",
        "portrait": "Portrait",
        "expressionSheet": "Expressions",
        "gaitReference": "Gait",
        "actionBeat": "Action beat",
        "voiceDemo": "Voice",
        "referenceInput": "Reference",
        "previz": "Previz",
        "wallFace": "Wall"
      }
    },
    "view": {
      "grid": "Grid",
      "list": "List"
    },
    "group": {
      "latest": "latest"
    },
    "search": {
      "placeholder": "Search the library",
      "hint": "Searches the whole project: shot prompts, names, file names",
      "clear": "Clear search",
      "tooShort": "Type at least two characters",
      "searching": "Searching…",
      "empty": "Nothing matched “{{query}}”",
      "failed": "Search failed.",
      "placesGroup": "Folders",
      "assetsGroup": "Assets",
      "truncated": "Showing the first matches — narrow the query down",
      "field": {
        "storyboardPrompt": "Frame prompt",
        "videoPrompt": "Video prompt",
        "intent": "Shot intent",
        "promptSummary": "Prompt summary",
        "title": "Title",
        "name": "Name",
        "outfit": "Outfit",
        "variant": "Variant",
        "viewpoint": "Viewpoint",
        "state": "State",
        "prompt": "Prompt",
        "filename": "File name"
      }
    },
    "filters": {
      "label": "Filter by type",
      "all": "All",
      "video": "Video",
      "image": "Frames",
      "audio": "Audio"
    },
    "tree": {
      "season": "Season {{number}}",
      "episodeFallback": "Episode {{number}}",
      "animatic": "Animatic",
      "sceneLabel": "Scene {{number}}",
      "shotLabel": "Shot {{number}}",
      "transitionShot": "Transition shot",
      "toggleNode": "Expand or collapse",
      "noShots": "No shots in the project yet.",
      "noCanvases": "No Canvas boards yet.",
      "noFlows": "No Flow boards yet.",
      "no": {
        "characters": "No characters in the project yet.",
        "locations": "No locations in the project yet.",
        "props": "No props in the project yet.",
        "scenes_3d": "No 3D scenes in this project yet."
      }
    },
    "crumbs": {
      "scene": "Sc. {{number}}",
      "shot": "Shot {{number}}",
      "animatic": "Animatic"
    },
    "folders": {
      "noScenes": "No scenes in this episode yet.",
      "noShots": "No shots in this scene yet.",
      "empty": "No assets yet."
    },
    "shot": {
      "openShot": "Open shot",
      "open": "Open",
      "storyboard": "Key frame",
      "shootingBoard": "Shooting board",
      "video": "Video",
      "capture": "Screenshot",
      "references": "References",
      "audio": "Audio",
      "audioFallback": "Audio",
      "animatics": "Animatics",
      "animaticFallback": "Animatic",
      "animaticLinked": "attached",
      "animaticDetached": "detached",
      "versionFallback": "Version",
      "versionEmpty": "No frames in this version yet.",
      "empty": "No assets in this shot yet."
    },
    "animatic": {
      "segmentLabel": "Segment {{number}}",
      "linkedShot": "shot {{number}}",
      "lockedToShot": "Already linked to shot {{number}}",
      "empty": "No segments in the animatic reel yet."
    },
    "flow": {
      "empty": "This board has no generated or uploaded files yet."
    },
    "canvas": {
      "empty": "No completed generations on this board yet.",
      "generationLabel": "Generation #{{id}}",
      "generationsGroup": "Generations",
      "uploadsGroup": "Uploads"
    },
    "sketches": {
      "empty": "No sketches saved yet."
    },
    "uploads": {
      "empty": "Nothing uploaded yet. Drop files here or press “Upload”.",
      "emptyReadOnly": "This project has no uploaded files yet.",
      "upload": "Upload",
      "hint": "Upload files to the project library: images, video, audio, up to 50 MB",
      "rename": "Rename",
      "renameNameLabel": "Name",
      "delete": "Delete upload",
      "deleteConfirm": "Delete",
      "deleteFailed": "Could not delete the upload.",
      "deleteWarning": "Delete “{{name}}” from the library? If the file is already used as a frame or reference, it stays there."
    },
    "previzes": {
      "empty": "No previzes yet. Record a camera flythrough in a location's 3D scene and save it to the library.",
      "noLocation": "No location",
      "linkedShot": "linked to a shot",
      "rename": "Rename",
      "renameNameLabel": "Name",
      "delete": "Delete previz",
      "deleteConfirm": "Delete",
      "deleteFailed": "Could not delete the previz.",
      "deleteWarning": "Delete previz “{{name}}”?",
      "status": {
        "pending": "Queued…",
        "processing": "Processing…",
        "draft": "Draft",
        "failed": "Processing failed"
      }
    },
    "columns": {
      "name": "Name",
      "type": "Kind",
      "duration": "Duration",
      "date": "Date",
      "current": "Active version"
    },
    "types": {
      "folder": "Folder",
      "image": "Image",
      "video": "Video",
      "audio": "Audio"
    },
    "viewer": {
      "fps": "{{fps}} fps",
      "noPreview": "This file cannot be previewed.",
      "prev": "Previous",
      "next": "Next"
    },
    "pick": {
      "description": "Pick an asset, then assign it with a button below.",
      "chooseProject": "Choose a project",
      "noProjects": "No projects available",
      "nothingSelected": "No asset selected",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "selectedOfLimit": "{{count}} of {{limit}} selected",
      "removeFromSelection": "Remove \"{{label}}\" from selection",
      "toggle": "Select",
      "toggleTree": "Show or hide the folder tree",
      "reason": {
        "needMedia": "This slot takes {{kinds}}",
        "notReady": "The file is still being prepared",
        "noSource": "There is no file behind this preview",
        "alreadyPicked": "Already attached",
        "limitReached": "You can pick at most {{count}} at a time"
      },
      "media": {
        "image": "an image",
        "video": "a video",
        "audio": "audio",
        "animatic": "an animatic segment",
        "shot_animatic": "a shot animatic",
        "previz": "a previz",
        "or": " or "
      }
    }
  },
  "analytics": {
    "headTitle": "Analytics",
    "title": "Analytics",
    "subtitle": "Production summary and pipeline bottlenecks.",
    "kpiEpisodes": "Episodes (approved/total)",
    "kpiScenes": "Scenes (approved/total)",
    "kpiStoryboard": "Shots with storyboard",
    "kpiVideo": "Shots with video",
    "kpiErrors": "Generation errors",
    "kpiQueued": "Queued jobs",
    "kpiRuntime": "Runtime",
    "readinessTitle": "Average visual readiness",
    "bottlenecksTitle": "Bottlenecks",
    "noBottlenecks": "No obvious blockers",
    "pipelineTitle": "Stage distribution"
  },
  "camerasPage": {
    "headTitle": "Cameras",
    "title": "Camera setup library",
    "studioTitle": "System camera presets",
    "companyTitle": "Camera presets",
    "selectHint": "Select a camera on the left to open its card.",
    "newCameraName": "New camera",
    "saveFailed": "Could not save the camera",
    "deleteConfirmTitle": "Delete camera “{{name}}”?",
    "deleteConfirmMessage": "This cannot be undone.",
    "deleteConfirmAction": "Delete",
    "destroyBlocked": "The camera is used in shots.",
    "copied": "Camera copied",
    "addCamera": "Add camera",
    "actionsAria": "Camera list actions",
    "empty": "No cameras yet.",
    "sections": {
      "system": "System",
      "company": "Company",
      "project": "Project"
    },
    "builtinBadge": "Built-in",
    "hiddenBadge": "Hidden",
    "addFavorite": "Add to favorites",
    "removeFavorite": "Remove from favorites",
    "delete": "Delete",
    "demoTitle": "Demo",
    "demoEmpty": "No demo yet",
    "demoFailed": "Failed to generate camera demo",
    "demoReady": "Camera demo is ready",
    "emptyPrompt": "Add a prompt fragment first",
    "demoProvidersOnly": "Camera demo needs a configured project video provider",
    "regenerate": "Regenerate",
    "generate": "Generate",
    "promptLabel": "System prompt fragment",
    "promptPlaceholder": "Describe the camera movement…",
    "descriptionLabel": "Description",
    "narrativeLabel": "Narrative purpose",
    "whenLabel": "When to apply",
    "tagsLabel": "Tags",
    "tagsPlaceholder": "comma, separated, tags",
    "listTitle": "Cameras",
    "filterPlaceholder": "Search by name…",
    "clearFilter": "Clear search",
    "filterEmpty": "No matches.",
    "hide": "Hide",
    "restore": "Show",
    "copyToProject": "Copy to project",
    "copyToCompany": "Copy to company",
    "pickerTitle": "Pick a camera",
    "close": "Close",
    "previewPlay": "Play preview",
    "previewPause": "Pause preview",
    "previewLoading": "Loading preview…",
    "searchPlaceholder": "Search cameras…",
    "noResults": "No cameras found",
    "pickerLoading": "Loading cameras…",
    "loadFailed": "Could not load cameras"
  },
  "versions": {
    "headTitle": "Versions",
    "title": "Version history",
    "subtitle": "Automatic snapshots before episode and scene regeneration. Restore replaces current data; a new “as-is” snapshot is created first so you can roll back again.",
    "derivedFrom": "Based on: snapshot #{{id}}",
    "restoreButton": "Restore from snapshot",
    "doubleClickRestore": "Double-click to restore from snapshot (with confirmation)",
    "restoreHintEpisodes": "Replaces all episodes in the selected season and nested scenes and shots with the snapshot state. Current data is archived first.",
    "restoreHintScenes": "Archives current active scenes and shots in the episode and restores the tree from the snapshot; old records and media remain in the database (archived_at).",
    "restoreConfirm": "{{hint}}\n\nContinue restoring snapshot “{{label}}”?",
    "notRestorable": "Restore from this snapshot type is not supported yet (only “episodes” and “scenes”)."
  },
  "script": {
    "headTitle": "Script",
    "title": "Script",
    "originalStory": "Original story",
    "episodeFallback": "Episode {{number}}",
    "editingOriginalStory": "Project original story",
    "save": "Save",
    "seasonEpisodeLabel": "Season {{season}} · E{{episode}}",
    "saveEpisode": "Save episode",
    "scopePickerAria": "Original story or episode",
    "editorAriaLabel": "Script text",
    "editorPlaceholder": "Write the story here…",
    "askAgent": "Ask assistant",
    "makeShots": "Make shots",
    "askAgentMessage": "Look at this excerpt and answer:\n\n{{excerpt}}",
    "makeShotsMessage": "Break this excerpt into scenes and shots:\n\n{{excerpt}}",
    "extractCharactersTitle": "Extract characters?",
    "extractCharactersMessage": "The assistant will create or update characters from the script.",
    "extractLocationsTitle": "Extract locations?",
    "extractLocationsMessage": "The assistant will create or update locations from the script.",
    "extractConfirm": "Extract",
    "assistantTab": "Screenwriter assistant",
    "screenplayPlaceholder": "INT. PLACE — TIME. Enter — next element, Tab — change type",
    "scenesTab": "Scenes",
    "versionsTab": "Versions",
    "synopsisHeading": "Synopsis",
    "importSynopsis": "Move synopsis into the script",
    "scenesHeading": "Scenes · {{count}}",
    "untitledScene": "Untitled",
    "sceneMeta": "{{length}} pg · ≈ {{time}} · p. {{pages}}",
    "pagesValue": "{{value}} pg",
    "timingHint": "For reference: 1 page ≈ 1 minute",
    "draftsHeading": "Drafts",
    "draftLabelPlaceholder": "Draft name",
    "saveDraft": "Save",
    "historyHeading": "Edit history",
    "revisionEdit": "Edits · {{author}}",
    "revisionEvent": {
      "before_restore": "Before restore",
      "restored": "Restored from {{source}}"
    },
    "saveFailed": "Could not save the script",
    "restoreConfirm": "Apply “{{label}}” as the current text? The current text stays in the edit history.",
    "unsaved": "unsaved changes",
    "savedAt": "saved at {{time}}",
    "comparingWith": "comparing with “{{label}}”",
    "viewSheets": "Pages",
    "viewFlow": "Flow",
    "paperTheme": "Paper matches theme",
    "paperLight": "Light paper",
    "compareInline": "Inline",
    "compareSide": "Side by side",
    "restoreVersion": "Apply",
    "closeCompare": "Close",
    "elementAria": "Screenplay element",
    "elements": {
      "scene": "Scene",
      "action": "Action",
      "character": "Character",
      "parenthetical": "Parenthetical",
      "dialogue": "Dialogue",
      "transition": "Transition"
    },
    "more": "(MORE)",
    "contd": "(CONT'D)",
    "pageLabel": "page {{page}}",
    "seasonFallback": "Season {{number}}",
    "seasonSummary": "Episodes: {{episodes}} · scripts: {{written}} · {{pages}} pg · ≈ {{time}} of {{target}}",
    "editStory": "Edit",
    "storyEmpty": "The source story is not written yet.",
    "writeScript": "Write script",
    "addSynopsis": "Add synopsis",
    "syncScenes": "Update episode scenes",
    "syncScenesHint": "Create and update the episode scenes from INT./EXT. headings: title, text, duration, location and cast. Scenes without a heading are kept.",
    "syncScenesDone": "Scenes from the script: {{created}} new, {{updated}} updated, {{unmatched}} without a heading",
    "backToList": "Back to scripts"
  },
  "video": {
    "missingFrameConfirm": {
      "title": "Key frame is not ready yet",
      "message": "Some shots do not have a key frame yet. Without it, the model will rely only on the prompt and reference materials. Continue generating video without a key frame?",
      "confirm": "Generate video without frame"
    }
  },
  "header": {
    "viewOnly": "View only",
    "sharedAccess": "Shared access",
    "settingsAccess": "Settings access",
    "changeFrameFormat": "Change format"
  },
  "promptOverrides": {
    "loadFailed": "Could not load prompt data.",
    "saveFailed": "Save failed.",
    "resetFailed": "Reset failed.",
    "networkError": "Network error.",
    "loading": "Loading prompts…",
    "templatesTitle": "Templates",
    "templatesHint": "Green bar — project override for this template.",
    "overridden": "overridden",
    "projectOverride": "Project override",
    "globalValue": "Global value (no override)",
    "globalValueHeading": "Global value",
    "copyAsBase": "Copy as base",
    "empty": "(empty)",
    "projectOverrideLabel": "Project override",
    "projectOverrideHint": "Leave empty to use the global value.",
    "overridePlaceholder": "Leave empty to use the global prompt",
    "saveOverride": "Save override",
    "resetToGlobal": "Reset to global",
    "selectTemplate": "Select a template from the list on the left."
  },
  "providers": {
    "intro": "Generation models for this project. Defaults are inherited from",
    "studioAi": "Studio → Platform Config",
    "text": "Text",
    "storyboardImages": "Storyboard images",
    "defaultFromStudio": "Default (from Studio)",
    "defaultFromStudioShort": "Default from Studio",
    "studioDefaultNow": "Currently: {{model}}",
    "frameCorrection": "Frame correction",
    "locations": "Locations",
    "characters": "Characters",
    "characterOutfits": "Character outfits",
    "cover": "Cover",
    "video": "Video",
    "resolution": "Video resolution",
    "generateSyncedAudio": "Generate synchronized audio",
    "seedanceDraftDefault": "Seedance: draft at 480p by default",
    "generateSyncedAudioHint": "Off — silent output. Animatic, voices, and audio references are still used for lip-sync and rhythm.",
    "klingVariantFidelity": "Kling: location variant image_fidelity",
    "klingOutfitFidelity": "Kling: character outfit image_fidelity",
    "animaticPromptBlock": "Prompt block when using animatic reference (@Video1)",
    "animaticPromptPlaceholder": "Empty — text from Studio → System prompts (seedance_animatic_reference_video)",
    "animaticPromptHint": "Appended to the user video prompt when animatic segment is sent as reference video. Overrides the global template for this project only.",
    "videoCorrection": "Video correction",
    "voiceTts": "Voice (TTS)",
    "voiceCreation": "Voice creation",
    "audioTranscription": "Audio transcription"
  },
  "overview": {
    "headTitle": "{{name}} — overview",
    "title": "Project overview",
    "storyAndFormat": "Story & format",
    "editStoryAndFormat": "Edit story and format",
    "projectType": "Type",
    "genre": "Genre",
    "narrativeTone": "Narrative tone",
    "tone": "Tone",
    "medium": "Medium",
    "visualStyle": "Visual style",
    "stylesDisabled": "No styles",
    "format": "Format",
    "deprecatedValue": "Current value is outdated: «{{value}}». Pick an up-to-date option from the catalog.",
    "workingEpisode": "Working episode",
    "workingEpisodeHint": "Team-wide pointer. Personal switches on storyboard and other pages are saved separately.",
    "countsLine": "Seasons: {{seasons}} · Episodes: {{episodes}} · Scenes: {{scenes}} · Shots: {{shots}}",
    "readinessLine": "Average visual readiness (storyboard + video per shot): {{value}}",
    "approveStory": "Approve story",
    "approveStoryDisabled": "Story is already approved. Edit text in Script or Settings, then click here again.",
    "originalStory": "Original story text",
    "showFull": "Show full text",
    "loading": "Loading…",
    "excerptHint": "Only the opening excerpt is loaded in overview — full text loads on request.",
    "loadFailed": "Could not load text",
    "noStory": "No text yet. Open Script or create a project with a story description.",
    "cast": "Cast",
    "castSection": "Characters",
    "castHint": "Project characters; thumbnail is the reference if already generated.",
    "noPhoto": "No photo",
    "noCharacters": "No characters yet. Add manually or extract from the story in",
    "charactersLink": "Characters",
    "openCharacters": "Open Characters",
    "extractCharacters": "Extract characters from story",
    "locations": "Locations",
    "locationsHint": "Project locations; thumbnail is the reference if already generated.",
    "noLocations": "No locations yet. Add manually or extract from the story in",
    "locationsLink": "Locations",
    "openLocations": "Open Locations",
    "extractLocations": "Extract locations from story",
    "props": "Props",
    "propsHint": "Project props; thumbnail is the reference if already generated.",
    "noProps": "No props yet. Add manually or extract from the story in",
    "propsLink": "Props",
    "openProps": "Open Props",
    "extractProps": "Extract props from story",
    "extractPropsConfirmTitle": "Extract props from story?",
    "extractPropsConfirmMessage": "The LLM will analyze the source story and add or update project props. Manually created items will be kept.",
    "extractPropsConfirmAction": "Extract",
    "extractPropsBusy": "Extracting…",
    "cover": "Project cover",
    "model": "Model",
    "noCover": "No cover yet.",
    "noCoverHint": "Approve the story — cover will be created automatically, or click the button below.",
    "regenerateCover": "Regenerate cover",
    "uploadCover": "Upload cover",
    "watchAssembly": "Watch assembly",
    "team": "Team",
    "author": "Author",
    "teamOpen": "Open team",
    "teamUnnamed": "Unnamed",
    "sharedWith": "shared",
    "readiness": "Readiness",
    "readinessHint": "Episodes, scenes, storyboard and video per shot (approved / total).",
    "statsRecalculating": "Structure generation in progress — counts update when it finishes",
    "kpiEpisodes": "Episodes ready",
    "kpiScenes": "Scenes confirmed",
    "kpiStoryboard": "Storyboard",
    "kpiVideo": "Video clips",
    "kpiRuntime": "Runtime",
    "assemblyBuilds": "Episode assemblies",
    "assemblyHint": "Ready MP4s and recent merge jobs. Full assembly — in Assembly.",
    "readyFiles": "Ready files",
    "assemblyLink": "Assembly",
    "openInPlayer": "Open in player",
    "download": "Download",
    "mergeJobs": "Recent merge jobs",
    "episodeNotSpecified": "Episode not specified",
    "defaultFromStudio": "Default from Studio",
    "recentGenerations": "Recent generations",
    "recentGenerationsHint": "Canvas and shots",
    "recentGenerationsEmpty": "No completed generations in this project yet.",
    "canvasModalLoadFailed": "Could not load canvas generation",
    "flowNodeMissing": "That flow node is gone",
    "unknownAuthor": "No author",
    "kindImage": "Image",
    "kindVideo": "Video",
    "subjectCanvas": "Canvas #{{id}}",
    "subjectFlow": "{{title}}",
    "subjectFlowMissing": "Flow",
    "openShot": "Open shot",
    "lastEditedShot": "Last edited shot",
    "noShotsYet": "No shots yet — create the first one to start storyboarding.",
    "createFirstShot": "Create first shot",
    "createFirstShotHint": "Season, episode, and scene will be created automatically if missing.",
    "shotNoDescription": "No description",
    "jobs": "Jobs",
    "versions": "Versions",
    "teamEmpty": "Team members will appear here after invitations."
  },
  "studioAssembly": {
    "assembly": "Assembly",
    "studio": "Studio",
    "storyboardSource": "Storyboard",
    "openInStudio": "Open in studio",
    "storyboardSourceHint": "Current storyboard state",
    "customAssemblies": "Assemblies",
    "storyboardReadonly": "Shot order follows the storyboard. Create an assembly to rearrange them.",
    "storyboardEmptyScene": "No shots in this scene."
  },
  "assembly": {
    "headTitle": "Assembly",
    "title": "Assembly",
    "episode": "Episode",
    "noEpisodes": "No episodes — generate episodes first.",
    "tabTimeline": "Timeline",
    "tabHistory": "History",
    "tabHistoryCount": "History ({{count}})",
    "assembled": "Assembled:",
    "assembledSeconds": "{{seconds}} s",
    "target": "target ~{{seconds}} s",
    "mutedCount_one": "({{count}} muted)",
    "mutedCount_other": "({{count}} muted)",
    "underTarget": "Runtime is below target — add clips or lengthen shots.",
    "missingClips": "Some shots have no video.",
    "saveOrder": "Save order",
    "mergeEpisode": "Merge episode",
    "mergeEpisodeTitle": "Queue merge job",
    "actionsAria": "Assembly actions",
    "previewBuild": "Preview build",
    "overlap": "Overlap:",
    "overlapNone": "No overlap",
    "overlapTransitions": "For transitions",
    "overlapAll": "For all frames",
    "shotNumbers": "Shot numbers",
    "statsTitle": "Runtime",
    "settingsTitle": "Assembly settings",
    "sceneLabel": "Scene {{number}}",
    "shotsCount_one": "{{count}} shot",
    "shotsCount_other": "{{count}} shots",
    "sceneDuration": "{{seconds}} s",
    "emptyScene": "No shots in this scene — drop here.",
    "dragScene": "Drag scene",
    "dragShot": "Drag shot",
    "saving": "Saving…",
    "saved": "Saved",
    "saveFailed": "Save failed",
    "timeline": "Timeline",
    "timelineHint": "Order follows the episode structure: scenes by number, shots in order. Changes are saved automatically.",
    "noShots": "No shots in this episode — generate structure and shots first.",
    "clipAria": "Clip {{label}}, {{seconds}} s{{muted}}",
    "clipMutedSuffix": ", muted",
    "muteInAssembly": "Mute in assembly",
    "unmuteInAssembly": "Unmute in assembly",
    "noClip": "No clip",
    "stitchScene": "Stitch",
    "selectionLabel": "Selected shots ({{count}})",
    "clipPreview": {
      "title": "Shot {{label}}",
      "titleWithScene": "Shot {{label}} — {{scene}}",
      "open": "Open shot {{label}} preview",
      "noMedia": "No video or image for this shot",
      "prev": "Previous shot",
      "next": "Next shot"
    },
    "selection": {
      "count": "Selected: {{count}}",
      "selectAll": "Select all",
      "clear": "Clear",
      "mute": "Mute",
      "unmute": "Unmute",
      "stitch": "Stitch"
    },
    "noHistory": "No assembly history for this episode.",
    "clipsCount_one": "{{count}} clip",
    "clipsCount_other": "{{count}} clips",
    "fileUnavailable": "File was not saved — this build predates cloud storage",
    "preview": "Preview",
    "exportNoEpisode": "Episode not selected",
    "exportNoEpisodeMsg": "Select an episode in the list above.",
    "exportEmptyTimeline": "Empty timeline",
    "exportEmptyTimelineMsg": "No active clips on the timeline.",
    "exportDataError": "Data error",
    "exportDataErrorMsg": "Could not determine shot ids. Refresh the page.",
    "exportNoVideo": "No video to merge",
    "exportNoVideoMsg": "None of the active shots have a generated clip.",
    "shotFallback": "Shot #{{id}}",
    "overlapLabels": {
      "none": "No overlap",
      "transitions_only": "Overlap for transitions",
      "all": "Overlap for all frames"
    },
    "result": {
      "ready": "Latest build",
      "readyFresh": "Merge complete",
      "newBadge": "new",
      "hint": "MP4 is ready to watch and download",
      "watch": "Watch",
      "download": "Download",
      "dismiss": "Hide",
      "dismissHint": "Hide — the build stays under “Preview build” and “Splices”"
    },
    "previewDialog": {
      "title": "Assembly preview",
      "hint": "Playback of the ready MP4. Download button below.",
      "downloadFile": "Download file",
      "paramsTitle": "Parameters",
      "resolution": "Resolution",
      "aspectRatio": "Aspect ratio",
      "shotsStitched": "Shots stitched",
      "duration": "Duration",
      "overlap": "Overlap mode",
      "muted": "Muted",
      "fileSize": "File size"
    },
    "exportDialog": {
      "gotIt": "Got it",
      "confirmMerge": "Confirm merge",
      "episode": "Episode",
      "scope": "Scope",
      "clips": "Clips",
      "muted": "Muted",
      "skippedVideosTitle_one": "{{count}} shot without video",
      "skippedVideosTitle_other": "{{count}} shots without video",
      "missingVideoTitle": "When video is missing",
      "substituteAnimatic": "Use animatic segment",
      "substituteShotImage": "Use shot image",
      "showShotLabelsOnVideo": "Show shot numbers on video",
      "overlapTitle": "Overlap",
      "merge": "Merge"
    },
    "empty": {
      "title": "No assemblies yet",
      "description": "Create an assembly to arrange scenes and shots independently from the storyboard. The first assembly copies the current storyboard order.",
      "create": "Create assembly"
    },
    "sidebar": {
      "versions": "Versions",
      "history": "History",
      "splices": "Splices",
      "versionsCount": "Versions ({{count}})",
      "splicesCount": "Splices ({{count}})",
      "togglePanel": "Versions & splices",
      "create": "Create assembly",
      "actionsMenu": "Assembly actions",
      "renameEdit": "Rename",
      "renameSave": "Save name",
      "renameCancel": "Cancel",
      "duplicate": "Duplicate",
      "deleteAssembly": "Delete",
      "deleteConfirm": "Delete assembly \"{{title}}\"? This cannot be undone.",
      "deleted": "Assembly deleted",
      "duplicated": "Assembly duplicated",
      "openPanel": "Open panel",
      "closePanel": "Collapse panel"
    }
  },
  "seasons": {
    "headTitle": "Seasons & episodes",
    "title": "Seasons & episodes",
    "reviewHint": "«In review» badges mean material awaits your decision. To unlock the next pipeline stage, approve ready entities (one by one or for the whole project):",
    "approveSeasonsTitle": "Marks all project seasons as approved",
    "approveSeasons": "Approve seasons",
    "approveEpisodesTitle": "Marks all project episodes as approved",
    "approveEpisodes": "Approve episodes",
    "approveScenesTitle": "Marks all project scenes as approved",
    "approveScenes": "Approve scenes",
    "approveShotsTitle": "Marks all project shots as approved",
    "approveShots": "Approve shots",
    "generateAllEpisodes": "Generate all episodes",
    "generateAllScenes": "Generate scenes (all episodes)",
    "generateAllShots": "Generate shots (all scenes)",
    "regenerateAllShots": "Regenerate all shots",
    "addSeason": "Add season",
    "openInStudio": "Open in Studio",
    "episodeFallback": "Episode {{number}}",
    "shotFallback": "Shot",
    "actionsAria": "Season actions",
    "seasonTitle": "Season {{number}}: {{title}}",
    "addEpisode": "Add episode",
    "editSeason": "Edit season",
    "deleteSeason": "Delete season",
    "deleteSeasonBlocked": "Cannot delete a season with shots",
    "addFirstEpisode": "Add first episode",
    "editEpisode": "Edit episode",
    "deleteEpisode": "Delete episode",
    "deleteEpisodeBlocked": "Cannot delete an episode with shots",
    "addScene": "Add scene",
    "addFirstScene": "Add first scene",
    "sceneTitle": "Scene {{number}}: {{title}}",
    "editScene": "Edit scene",
    "archiveScene": "Archive scene",
    "addShot": "Add shot",
    "generationDetails": "Generation details",
    "location": "Location",
    "shotsCount_one": "{{count}} shot",
    "shotsCount_other": "{{count}} shots",
    "shotTitle": "Shot {{number}}",
    "allShotData": "All shot data",
    "llmDetails": "LLM details",
    "framePromptFull": "Frame prompt — full text",
    "llmFieldsHint": "By LLM fields (description / camera / …)",
    "regenerateSceneShots": "Regenerate scene shots",
    "regenerateSceneShotsTitle": "Regenerate shots for this scene",
    "dragScene": "Drag scene",
    "dragShot": "Drag shot",
    "loadError": "Load failed",
    "readFull": "Show full text",
    "closeSynopsis": "Close synopsis",
    "editSeasonDialog": "Edit season",
    "editEpisodeDialog": "Edit episode",
    "editSceneDialog": "Edit scene",
    "confirmGenerateEpisodes": "Start generating all episodes?",
    "confirmGenerateEpisodesMsg": "Episodes will be generated for all project seasons. Continue?",
    "confirmGenerateEpisodesAction": "Generate",
    "confirmGenerateScenes": "Start generating scenes?",
    "confirmGenerateScenesMsg": "Scenes will be generated for all project episodes. Continue?",
    "confirmGenerateScenesAction": "Generate",
    "confirmGenerateShots": "Start generating shots?",
    "confirmGenerateShotsMsg": "Shots will be generated for all project scenes. Continue?",
    "confirmGenerateShotsAction": "Generate",
    "confirmRegenerateShots": "Regenerate all shots?",
    "confirmRegenerateShotsMsg": "All shots in all project scenes will be regenerated. Continue?",
    "confirmRegenerateShotsAction": "Regenerate",
    "confirmEpisodesExist": "Episodes already exist",
    "confirmEpisodesExistMsg": "Re-running will create new episodes for seasons. Continue?",
    "confirmEpisodesExistAction": "Generate again",
    "confirmScenesExist": "Scenes already exist",
    "confirmScenesExistMsg": "Re-running will overwrite scenes per episode and archive the previous version. Continue?",
    "confirmScenesExistAction": "Regenerate scenes",
    "confirmShotsPartial": "Shots partially exist",
    "confirmShotsPartialMsg": "Re-running will generate only missing shots and leave existing ones. Continue?",
    "confirmShotsPartialAction": "Generate missing",
    "confirmShotsExist": "Shots already exist",
    "confirmShotsExistMsg": "Re-running will regenerate all shots in all scenes, keeping manual prompts and storyboard preview. Continue?",
    "confirmShotsExistAction": "Regenerate all shots",
    "confirmSceneShotsExist": "Shots for this scene already exist",
    "confirmSceneShotsExistMsg": "Re-running will regenerate shots for this scene only. Continue?",
    "confirmSceneShotsExistAction": "Regenerate scene shots",
    "deleteSeasonTitle": "Delete season?",
    "deleteSeasonMsg": "Season «{{title}}» and all its episodes, scenes and shots will be deleted permanently.",
    "deleteEpisodeTitle": "Delete episode?",
    "deleteEpisodeMsg": "Episode «{{title}}» and all its scenes and shots will be deleted permanently.",
    "archiveSceneTitle": "Archive scene?",
    "archiveSceneMsg": "Scene «{{title}}» will be archived.",
    "delete": "Delete",
    "archive": "Archive",
    "dialogs": {
      "seasonName": "Name",
      "seasonDescription": "Description",
      "episodeName": "Name",
      "episodeDescription": "Description",
      "episodeDuration": "Duration (sec)",
      "sceneName": "Name",
      "scenePurpose": "Scene purpose",
      "sceneDuration": "Duration (sec)",
      "sceneDurationPlaceholder": "Or enter manually…",
      "sceneLocation": "Location",
      "locationNotSet": "— Not set —",
      "shotLlmTitle": "Shot breakdown (LLM) — {{label}}",
      "shotLlmEmpty": "No generation data.",
      "shotLlmDescription": "Description",
      "shotLlmVisualDetails": "Visual details",
      "shotLlmShotType": "Shot type",
      "shotLlmCamera": "Camera",
      "shotLlmVisual": "Visual",
      "shotLlmAction": "Action",
      "shotLlmDialogue": "Dialogue",
      "shotLlmSound": "Sound",
      "shotLlmEmotion": "Emotion",
      "sceneLlmTitle": "Generation details — {{title}}",
      "sceneLlmEmpty": "No generation data.",
      "sceneLlmCharacters": "Characters in frame",
      "sceneLlmMood": "Mood",
      "sceneLlmLocationText": "Location in text",
      "sceneLlmVisualAnchors": "Visual anchors",
      "sceneLlmDialogue": "Lines",
      "sceneLlmCharacterFallback": "Character",
      "sceneLlmSound": "Sound",
      "sceneLlmAtmosphere": "Atmosphere:",
      "sceneLlmMusic": "Music:"
    }
  },
  "storyboard": {
    "headTitle": "Storyboard",
    "title": "Storyboard",
    "untitled": "Untitled",
    "format": "Format:",
    "target": "Target:",
    "addScene": "Add scene",
    "createSeries": "Create series",
    "noSeriesHint": "This project has no series yet. Create the first one to start working on the storyboard.",
    "episode": "Episode",
    "noEpisodes": "No episodes",
    "jobs": "Jobs",
    "versions": "Versions",
    "timelineHint": "Episode timeline: each scene is a separate row with a «Scene» block and its {{format}} frames wrapping by width. Click a preview to open the shot. Click the caption below a frame to select the shot: the shot assistant opens on the right, the shot itself stays closed. Shift+click a caption to add the shot to the selection or remove it; Esc clears the selection.",
    "timelineHintTitle": "Timeline help",
    "timelineHintAria": "Timeline help",
    "sceneShotsFromScriptPrompt": "Break scene {{number}} “{{title}}” into shots from the script",
    "sceneShotsFromScriptPromptUntitled": "Break scene {{number}} into shots from the script",
    "hiddenShot": "Hidden shot {{label}} — click to view",
    "insertShotBefore": "Insert shot before",
    "insertShotAfter": "Insert shot after",
    "selectEpisode": "Select an episode",
    "animaticSegment": "Animatic segment",
    "segment": "Segment:",
    "start": "Start:",
    "end": "End:",
    "duration": "Duration:",
    "episodeLabel": "Episode:",
    "segmentFrames": "Segment frames",
    "firstFrame": "First frame",
    "poster": "Poster",
    "lastFrame": "Last frame",
    "noSegmentData": "No segment data.",
    "actionsAria": "Storyboard actions",
    "createFrames": "Create frames ({{count}})",
    "createAllFrames": "Create all frames",
    "createVideo": "Create video ({{count}})",
    "createAllVideo": "Create all video",
    "missingStoryboardHint": "Some selected shots have no frame — generate frames first",
    "noAnimaticSegment": "Shot has no animatic segment.",
    "segmentLoadFailed": "Could not load segment data.",
    "saveFailed": "Save failed",
    "tile": {
      "previewShot": "View shot {{label}}",
      "selectShotNoFrame": "Select shot {{label}} for generation (no frame)",
      "noFrameGenerate": "No frame — generate",
      "generatingVideo": "Video…",
      "generatingFrame": "Frame…",
      "charactersAria": "Shot characters: {{count}}, configure links",
      "noPeopleMode": "«No people» mode: figures are blocked in the prompt; character references are not used. Configure.",
      "charactersTitle": "Scene and shot characters — link or unlink",
      "locationAria": "Shot location: {{location}}",
      "locationNotSet": "not set",
      "locationTitle": "Location: {{name}}",
      "linkLocation": "Link location",
      "propsAria": "Shot props: {{count}}, configure assignment",
      "propsTitle": "Shot props — link or unlink",
      "animaticSegment": "Animatic segment",
      "linkedAnimatic": "Linked to animatic",
      "uploadFrame": "Upload frame",
      "uploadFrameTitle": "Upload frame from computer",
      "storyboardVersions": "Storyboard versions",
      "shootingBoard": "Shooting board",
      "videoVersions": "Video versions",
      "selectShotAria": "Select shot {{label}} for generation",
      "deselectShotAria": "Deselect shot {{label}}",
      "shotFallback": "Shot",
      "editShot": "Edit shot",
      "editDescription": "Edit description",
      "editDescriptionShot": "Edit shot description",
      "generatingStatus": "Generating",
      "correctingStatus": "Correcting",
      "errorStatus": "Error",
      "errorDetailsTitle": "Generation error — {{label}}",
      "newStatus": "New",
      "statusLabel": "Status",
      "reviewCommentPlaceholder": "Comment on changes…",
      "shotFormatDiffers": "Shot format: {{shotFormat}} (project {{projectFormat}})",
      "heroesUpdated": "Updated after the last generation: {{names}}"
    },
    "createShot": {
      "transitionTitle": "Transition shot {{label}}",
      "newShotTitle": "New shot {{label}}",
      "sceneHint": "Scene {{sceneNumber}}: {{title}}. Shot will be inserted after position {{position}}.",
      "makeTransition": "Make transition shot",
      "transitionBetween": "A special transition shot will be created between shot {{left}} and shot {{right}}.",
      "transitionEpisodeStart": "A loop transition will be created before the start of the episode: last frame of shot {{last}} → first frame of shot {{first}}.",
      "transitionEpisodeEnd": "A loop transition will be created after the end of the episode: last frame of shot {{last}} → first frame of shot {{first}}.",
      "transitionFrames": "Last frame of shot {{left}} and first frame of shot {{right}} will be used for interpolation.",
      "transitionEpisodeFrames": "Last frame of shot {{last}} and first frame of shot {{first}} will be used for loop interpolation.",
      "lastFrameAlt": "Last frame of shot {{number}}",
      "lastFrameLabel": "Shot {{label}} — last frame",
      "firstFrameAlt": "First frame of shot {{number}}",
      "firstFrameLabel": "Shot {{label}} — first frame",
      "transitionDescription": "Transition description",
      "shotDescription": "Shot description",
      "transitionPlaceholder": "How the transition happens: smooth blend, flash, camera push…",
      "shotPlaceholder": "Briefly: what happens in the frame…",
      "autoFillHint": "If left empty — will be filled automatically",
      "duration": "Duration",
      "characters": "Characters",
      "location": "Location",
      "noLocation": "No location",
      "useNeighborLastFrame": "Use last frame of neighbor shot video",
      "neighborLastFrameHint": "Last video frame of shot {{number}} will be set as the new shot storyboard",
      "creating": "Creating…",
      "createTransition": "Create transition",
      "createShot": "Create shot",
      "untitledScene": "untitled",
      "numberUnavailable": "No free shot number between the neighboring shots.",
      "cannotCreateTitle": "Unable to create a shot",
      "cannotCreateHint": "There is no free number between these shots. To insert a shot here, delete the next one first."
    }
  },
  "entityProfile": {
    "mentionHint": "Type @ for attributes",
    "generationModel": "Generation model",
    "projectSettings": "Project settings",
    "save": "Save",
    "saving": "Saving…",
    "savedState": "Saved",
    "saveErrorRetry": "Error — retry",
    "sections": {
      "height": "Height",
      "role": "Role",
      "short_description": "Short description",
      "personality": "Personality",
      "appearance_summary": "Appearance",
      "visual_prompt_summary": "Visual details",
      "gait": "Gait",
      "voice": "Voice",
      "description": "Description",
      "mood": "Mood / atmosphere",
      "visual_traits": "Visual traits",
      "diagonal_size": "Diagonal size",
      "category": "Category",
      "visual_description": "Visual description",
      "purpose": "Purpose",
      "materials": "Materials",
      "features": "Features",
      "consistency_notes": "Consistency notes"
    }
  },
  "assetMedia": {
    "clearVersion": "Delete",
    "clearVersionConfirm": "Delete the current version?\nThe current version will stay in history."
  },
  "charactersPage": {
    "headTitle": "Characters",
    "title": "Characters",
    "listTitle_one": "Characters · {{count}}",
    "listTitle_few": "Characters · {{count}}",
    "listTitle_many": "Characters · {{count}}",
    "listTitle_other": "Characters · {{count}}",
    "add": "Add character",
    "createCharacterSheet": "Create character sheet",
    "recreateCharacterSheet": "Recreate",
    "createCharacterSheetAssetsMissing": "Add at least one portrait, a headless reference, or a full-body reference first",
    "floatingActionsMenuAria": "More character list actions",
    "extractUpdate": "Extract / update",
    "assignToShots": "LLM determines which characters appear in each scene and assigns them to frames. Runs in background; empty model response does not clear existing cast.",
    "assignToShotsBtn": "Assign to frames",
    "assignToShotsConfirmTitle": "Assign characters to frames?",
    "assignToShotsConfirmMessage": "An LLM will determine scene participation and update cast in the background. An empty model response won't clear existing cast.",
    "assignToShotsConfirmAction": "Assign",
    "actionsAria": "Character list actions",
    "empty": {
      "title": "No characters yet",
      "description": "Add a character manually or extract them from the script"
    },
    "emptyList": "No characters yet. Click «Extract / update» or «Add character».",
    "selectLeft": "Select a character on the left to open the card.",
    "selectFromStrip": "Select a character above to open the card.",
    "createOrExtract": "Create or extract characters.",
    "queued": "Character queued…",
    "generate": "Generate character",
    "prompt": "Prompt",
    "versions": "Versions",
    "uploadVersion": "Upload file",
    "regenerate": "Regenerate",
    "correct": "Correct",
    "noReference": "No reference image to correct",
    "edit": "Edit",
    "replacePortrait": "Replace portrait",
    "replaceReferenceSheet": "Replace reference sheet",
    "replaceEmotionSheet": "Replace emotion sheet",
    "replaceOutfitImage": "Replace outfit",
    "editNameHint": "Click to rename",
    "delete": "Delete",
    "episodeVariants": "Per-episode variants",
    "reference": "Reference:",
    "model": "model",
    "configureStudio": "Configure in Studio",
    "referenceAlt": "Reference: {{name}}",
    "fieldShortDescription": "Short description",
    "fieldAppearance": "Appearance",
    "fieldVisualSummary": "Visual summary",
    "noDescriptions": "No descriptions yet. Open «Edit» to fill in.",
    "profileHeading": "Profile",
    "profilePlaceholder": "Describe the character. Insert attributes via @…",
    "outfits": "Outfits (clothing)",
    "addOutfit": "Add outfit",
    "noOutfits": "No outfits yet. By default the character uses the «base» reference.",
    "outfitQueuedHint": "Generation already queued — track progress in «Jobs»",
    "outfitNeedBaseHint": "Generate or upload base character reference first — it will be used for the outfit",
    "queuedShort": "Queued…",
    "noRef": "Not generated yet",
    "seedanceRegister": "Register asset",
    "seedanceRegisterAll": "Register all",
    "seedanceRegisterAllTitle": "Register every unregistered character and outfit reference in Seedance",
    "seedanceRegisterAllDoneTitle": "All available references are already registered in Seedance",
    "seedanceNeedReference": "Generate or upload a reference first",
    "seedanceRegistered": "In Seedance",
    "seedanceRegisteredButton": "Registered",
    "seedanceFailedHint": "Seedance registration failed — click to retry",
    "seedanceProcessing": "Registering…",
    "seedanceRegistrationStarted": "Registration started",
    "seedanceFailed": "Seedance error",
    "seedanceRegisterTitle": "Register the character image in the Seedance asset library",
    "destroyBlocked": "Character is used in scenes or shots.",
    "deleteCharacterConfirmTitle": "Delete character «{{name}}»?",
    "deleteCharacterConfirmMessage": "The character card and related reference versions will be deleted. This cannot be undone.",
    "deleteCharacterConfirmAction": "Delete",
    "deleteOutfitConfirmTitle": "Delete outfit «{{name}}»?",
    "deleteOutfitConfirmMessage": "Shot links will reset to the base character reference. This cannot be undone.",
    "deleteOutfitConfirmAction": "Delete",
    "newCharacter": "New character",
    "editCharacter": "Edit «{{name}}»",
    "referenceTitle": "Reference: {{name}}",
    "outfitTitle": "{{name}} · outfit «{{outfit}}»",
    "outfitAlt": "Outfit {{name}}",
    "outfitEnlargeAria": "Enlarge outfit «{{name}}» image",
    "newOutfit": "New outfit",
    "editOutfit": "Edit outfit «{{name}}»",
    "generating": "Generating…",
    "portraitTitle": "Portrait",
    "portraitEmpty": "Portrait not generated yet",
    "portraitViewEmpty": "{{view}} not generated yet",
    "portraitViews": {
      "front": "Front",
      "three_quarter_left": "3/4 left",
      "three_quarter_right": "3/4 right",
      "profile_left": "Left profile",
      "profile_right": "Right profile",
      "back": "Back"
    },
    "generatePortrait": "Generate portrait",
    "generatePortraitView": "Generate {{view}}",
    "regeneratePortraitView": "Regenerate this view",
    "generateReferenceSheet": "Generate",
    "generateExpressionSheet": "Generate",
    "generateGaitReference": "Generate",
    "generateActionBeat": "Generate",
    "portraitRequired": "Generate portrait first",
    "visualReferenceOptional": "Optional visual references for generation",
    "portraitVersionsTitle": "Portrait versions",
    "portraitCorrectTitle": "Correct portrait",
    "layoutTitle": "Layout",
    "referenceSheetTitle": "Reference sheet",
    "referenceSheetVersionsTitle": "Reference sheet versions",
    "outfitVersionsTitle": "Outfit versions",
    "characterSheetTitle": "Character sheet",
    "characterSheetNeedsUpdate": "References changed — recreate the character sheet",
    "characterSheetEmpty": "Character sheet not created yet",
    "characterSheetVersionsTitle": "Character sheet versions",
    "scaleSheetBtn": "Scale",
    "scaleSheetTitle": "Character scale sheet",
    "scaleSheetHint": "Adjust hero heights and preview relative sizes. Changes apply to all heroes in the project.",
    "scaleSheetHeightLabel": "Height",
    "scaleSheetDirtyCount": "{{count}} characters changed",
    "scaleSheetApplyAll": "Apply all",
    "scaleSheetNeedTwo": "Add at least one character.",
    "scaleSheetPreviewTitle": "Scale sheet",
    "scaleSheetLoadError": "Failed to load scale sheet",
    "scaleSheetSaveError": "Failed to save heights",
    "regenerateScalePose": "Regenerate A-pose",
    "scalePoseCharacterSheetRequired": "Generate a character sheet or reference sheet first",
    "close": "Close",
    "emotionSheetTitle": "Emotion sheet",
    "emotionSheetEmpty": "Emotion sheet not created yet",
    "generateEmotionSheet": "Generate",
    "regenerateEmotionSheet": "Regenerate",
    "emotionSheetVersionsTitle": "Emotion sheet versions",
    "emotionSheetPortraitRequired": "Add at least one portrait or angle first",
    "emotionSheetCorrectTitle": "Correct emotion sheet",
    "emotionSheetNoVersionHint": "Generate an emotion sheet first",
    "referenceSheetEmpty": "Reference sheet not generated yet",
    "referenceSheetEmptyHeadless": "Headless reference not generated yet",
    "referenceSheetScopeFullBody": "Full body",
    "referenceSheetScopeHeadless": "Headless",
    "referenceTitleHeadless": "Headless reference: {{name}}",
    "expressionSheetTitle": "Emotion demo",
    "expressionSheetVersionsTitle": "Emotion demo versions",
    "gaitReferenceTitle": "Gait demo",
    "gaitReferenceVersionsTitle": "Gait demo versions",
    "actionBeatTitle": "Action demo",
    "actionBeatVersionsTitle": "Action demo versions",
    "voiceDemoTitle": "Voice demo",
    "voiceDemoVersionsTitle": "Voice demo versions",
    "voiceDemoEmpty": "Voice demo not generated yet",
    "expressionSheetEmpty": "Emotion demo not generated yet",
    "gaitReferenceEmpty": "Gait demo not generated yet",
    "actionBeatEmpty": "Action demo not generated yet",
    "generateVoiceDemo": "Generate",
    "voiceCorrectTitle": "Correct voice demo",
    "mediaEmpty": "Not generated yet",
    "expressionCorrectTitle": "Correct emotion demo",
    "gaitCorrectTitle": "Correct gait demo",
    "actionCorrectTitle": "Correct action demo",
    "mediaDeleteConfirm": "Delete this media version?",
    "mediaGalleryHint": "Activate the version you need. Generated versions appear after jobs complete.",
    "mediaGalleryUpload": "Upload",
    "mediaGalleryLoading": "Loading versions…",
    "mediaGalleryEmpty": "No versions yet. Generate from the character card.",
    "mediaGalleryNoPreview": "No preview",
    "mediaGalleryActive": "Active",
    "mediaGalleryUploaded": "Uploaded",
    "mediaGalleryGenerated": "Generated",
    "mediaGalleryCleared": "Cleared",
    "mediaGalleryMakeActive": "Make active",
    "mediaCorrectionHint": "Describe what to change. A new version will be generated from the selected media.",
    "mediaCorrectionPlaceholder": "e.g. soften the smile, adjust hair color, brighter lighting…",
    "videoCorrectionPublicUrlHint": "Video correction needs a publicly reachable URL. Uploaded files on localhost may fail — use a tunnel if jobs error.",
    "sections": {
      "look": "Look",
      "emotions": "Emotions",
      "outfits": "Outfits",
      "sheet": "Hero sheet",
      "voice": "Voice",
      "overview": "Overview"
    },
    "overview": {
      "title": "All heroes",
      "stripLabel": "All",
      "portraits": "Portraits {{done}}/{{total}}",
      "outfits_one": "{{count}} outfit",
      "outfits_other": "{{count}} outfits",
      "notCreated": "Not created yet",
      "views_one": "{{count}} view",
      "views_other": "{{count}} views",
      "stale": "outdated",
      "openVoice": "Open voice",
      "zoom": "Zoom in: {{name}}",
      "viewsLabel": "Views",
      "onlyFront": "Front only — add more views"
    },
    "referenceViews": {
      "front": "Front",
      "three_quarter_front": "3/4 front",
      "profile_left": "Left profile",
      "profile_right": "Right profile",
      "three_quarter_back": "3/4 back",
      "back": "Back"
    },
    "emotions": {
      "neutral": "Neutral",
      "joy": "Joy",
      "anger": "Anger",
      "sadness": "Sadness",
      "surprise": "Surprise",
      "fear": "Fear",
      "disgust": "Disgust",
      "contempt": "Contempt",
      "embarrassment": "Embarrassment",
      "fatigue": "Fatigue",
      "determination": "Determination",
      "laughter": "Laughter",
      "scream": "Scream",
      "thoughtful": "Thoughtful"
    },
    "settings": {
      "viewCount": "Views",
      "portraitViewsHint": "Only the selected views are generated. Front is required; the others are built from it.",
      "referenceViewsHint": "Fewer views make the figure larger: the video reference is downscaled to 800 px. Use 4 or 6 for action and complex costumes.",
      "emotionSet_one": "Emotion set · {{count}}",
      "emotionSet_other": "Emotion set · {{count}}",
      "emotionsMax": "At most {{count}} emotions per sheet",
      "presetBase": "Basic",
      "presetDrama": "Drama",
      "presetOwn": "Custom",
      "customEmotion": "Custom emotion",
      "customEmotionPlaceholder": "Custom emotion, e.g. “holding back laughter”",
      "addEmotion": "Add emotion",
      "framing": "Framing",
      "framingFace": "Face",
      "framingWaist": "Waist up",
      "angle": "Angle",
      "angleThreeQuarter": "3/4",
      "captions": "Captions on sheet",
      "yes": "Yes",
      "no": "No",
      "captionsHint": "Without captions the sheet can go straight to video: the model won't carry text into the frame. Emotion names still go into the prompt.",
      "sheetFormat": "Sheet format",
      "sheetParts": "On the sheet",
      "parts": {
        "portraits": "Portraits",
        "full_body": "Turnaround",
        "headless": "Headless",
        "emotions": "Emotions",
        "name": "Hero name"
      },
      "formats": {
        "3x2": {
          "title": "3:2 · Classic",
          "hint": "Portrait grid, headless body and emotions, captioned"
        },
        "16x9": {
          "title": "16:9 · Video ref",
          "hint": "Large front face, full body and emotions for horizontal shots"
        },
        "9x16": {
          "title": "9:16 · Vertical",
          "hint": "For vertical projects, taller figure"
        },
        "1x1": {
          "title": "1:1 · Compact",
          "hint": "Face and full body, nothing extra"
        }
      },
      "videoReference": "Sent to video generation",
      "videoReferenceHint": "If the hero sheet is selected but missing, the turnaround is used.",
      "portraitViews": "Portrait views",
      "base": "base",
      "emotionSetTitle": "Set",
      "removeEmotion": "Remove “{{name}}”",
      "closeAdd": "Close",
      "framingSize": "Shot size",
      "readySets": "Presets",
      "sheetReused": "Found a ready sheet in this format and switched to it — no rebuild needed",
      "sheetReady": "ready"
    },
    "versionsFeed": {
      "title": "Previous versions",
      "titleOf": "Previous versions · {{name}}",
      "empty": "No other versions yet",
      "makeCurrent": "Make current",
      "zoom": "Zoom in on version from {{caption}}"
    },
    "outfitCatalog": {
      "new": "New",
      "all": "All",
      "onCharacter": "On hero",
      "garmentHint": "Clothing · invisible mannequin",
      "description": "Description",
      "noDescription": "No description",
      "inShot": "In a shot",
      "inShotGarment": "Sent together with {{name}}'s hero sheet: the model dresses the hero in these clothes.",
      "inShotOnCharacter": "Sent instead of the base hero sheet — with face, hair and makeup."
    },
    "cast": {
      "filters": {
        "all": "All",
        "ready": "Ready",
        "stale": "Outdated",
        "missing": "Not ready",
        "busy": "In progress"
      },
      "status": {
        "ready": "Ready for video",
        "sheetStale": "Sheet outdated",
        "generating": "Generating",
        "noPortrait": "Not ready: no portrait",
        "noLayout": "Not ready: no turnaround"
      },
      "assetState": {
        "busy": "in progress",
        "missing": "none",
        "stale": "rebuild",
        "create": "Create"
      },
      "assets": {
        "portrait": "portrait",
        "layout": "turnaround",
        "emotions": "emotion sheet",
        "sheet": "hero sheet",
        "outfits": "outfits"
      },
      "inVideo": "in video",
      "portraits": "Portraits {{done}}/{{total}}",
      "finishMissing": "Finish missing · {{count}}",
      "finishMessage": "Finish the missing hero assets in order: {{list}}. Portraits first, then turnarounds, emotions and sheets.",
      "emptyFilter": "No heroes with this status",
      "finishConfirmTitle": "Finish missing assets?",
      "finishConfirmIntro_one": "The heroes agent will generate {{count}} asset in order:",
      "finishConfirmIntro_other": "The heroes agent will generate {{count}} assets in order:",
      "finishConfirmHint": "Generations are charged to the project balance. Progress shows in the shared heroes chat.",
      "finishConfirmAction": "Start"
    },
    "voiceSummary": {
      "none": "No voice selected yet",
      "pick": "Pick a voice",
      "noPreview": "No preview",
      "open": "Open voice",
      "more_one": "{{count}} more voice",
      "more_other": "{{count}} more voices",
      "status": {
        "draft": "draft",
        "failed": "failed"
      }
    }
  },
  "propsPage": {
    "headTitle": "Props",
    "title": "Props",
    "add": "Add prop",
    "seedanceRegister": "Register asset",
    "seedanceNeedReference": "Generate or upload a reference first",
    "seedanceRegistered": "In Seedance",
    "seedanceRegisteredButton": "Registered",
    "seedanceFailedHint": "Seedance registration failed — click to retry",
    "seedanceProcessing": "Registering…",
    "seedanceRegisterTitle": "Register the prop reference in the Seedance asset library",
    "extractUpdate": "Extract / update",
    "extractConfirmTitle": "Extract / update props?",
    "extractConfirmMessage": "The LLM will analyze the source story and add or update project props. Manually created items will be kept.",
    "extractConfirmAction": "Extract / update",
    "empty": {
      "title": "No props yet",
      "description": "Add a prop manually or extract them from the script"
    },
    "selectFromStrip": "Select a prop above to open the card.",
    "createOrExtract": "Create or extract props.",
    "actionsAria": "Prop list actions",
    "floatingActionsMenuAria": "More prop actions",
    "editNameHint": "Click to rename",
    "generate": "Generate",
    "generateFrontView": "Generate",
    "regenerateFrontView": "Regenerate front view",
    "regenerate": "Regenerate",
    "uploadVersion": "Upload file",
    "referenceEmpty": "Reference sheet not generated yet",
    "layoutTitle": "Layout",
    "frontViewTitle": "Front view",
    "frontViewEmpty": "Front view not generated yet",
    "frontViewVersionsTitle": "Front view versions",
    "referenceSheetVersionsTitle": "Reference sheet versions",
    "stateVersionsTitle": "State versions",
    "prompt": "Prompt",
    "correct": "Correct",
    "replaceFrontView": "Replace front view",
    "replaceReferenceSheet": "Replace reference sheet",
    "replaceStateImage": "Replace state image",
    "noReference": "No reference image to correct",
    "edit": "Edit",
    "delete": "Delete",
    "episodeVariants": "Episode variants",
    "referenceTitle": "Reference sheet",
    "profilePlaceholder": "Describe the prop. Insert attributes via @…",
    "states": "States",
    "addState": "Add state",
    "noStates": "No states yet. By default the prop is shown in its «base» reference.",
    "stateQueuedHint": "Generation is already queued — track progress in the «Tasks» panel",
    "stateNeedBaseHint": "First generate or upload a base prop reference — it is used as the basis for the state",
    "stateTitle": "{{name}} · state «{{state}}»",
    "stateAlt": "State {{name}}",
    "stateEnlargeAria": "Enlarge state «{{name}}» image",
    "queuedShort": "Queued…",
    "noRef": "Not generated yet",
    "destroyBlocked": "The prop is used in shots.",
    "deleteProp": "Delete prop «{{name}}»?",
    "deleteState": "Delete state «{{name}}»? Linked shots will switch to the «base» reference.",
    "newProp": "New prop",
    "editProp": "Edit «{{name}}»",
    "newState": "New state",
    "editState": "Edit state «{{name}}»",
    "generating": "generating",
    "usageCount_one": "{{count}} shot",
    "usageCount_other": "{{count}} shots",
    "scaleSheetBtn": "Scale",
    "scaleSheetTitle": "Prop scale sheet",
    "scaleSheetHint": "Adjust prop diagonal sizes and preview relative sizes. Changes apply to all props in the project.",
    "scaleSheetHeightLabel": "Diagonal size",
    "scaleSheetDirtyCount": "{{count}} props changed",
    "scaleSheetApplyAll": "Apply all",
    "scaleSheetNeedTwo": "At least one prop is required for a scale sheet.",
    "scaleSheetPreviewTitle": "Prop scale sheet",
    "scaleSheetLoadError": "Failed to load prop scale sheet",
    "scaleSheetSaveError": "Failed to save diagonal sizes",
    "close": "Close"
  },
  "locationsPage": {
    "headTitle": "Locations",
    "title": "Locations",
    "listTitle_one": "Locations · {{count}}",
    "listTitle_few": "Locations · {{count}}",
    "listTitle_many": "Locations · {{count}}",
    "listTitle_other": "Locations · {{count}}",
    "add": "Add location",
    "seedanceRegister": "Register asset",
    "seedanceNeedReference": "Generate or upload a reference first",
    "seedanceRegistered": "In Seedance",
    "seedanceRegisteredButton": "Registered",
    "seedanceFailedHint": "Seedance registration failed — click to retry",
    "seedanceProcessing": "Registering…",
    "seedanceRegisterTitle": "Register the location reference in the Seedance asset library",
    "extractUpdate": "Extract / update",
    "extractHint": "Pulls locations from the script via the assistant: name matches are updated, new ones added. Existing locations are not deleted.",
    "assignToShots": "LLM picks a location for each scene and assigns it to frames without a location. Existing shot locations are not changed. Runs in background.",
    "assignToShotsBtn": "Assign locations to frames",
    "assignToShotsConfirmTitle": "Assign locations to frames?",
    "assignToShotsConfirmMessage": "LLM picks a location for each scene and assigns it to frames without a location. Existing shot locations are not changed. Runs in background.",
    "assignToShotsConfirmAction": "Assign",
    "emptyList": "No locations yet. Click «Extract / update» or «Add».",
    "empty": {
      "title": "No locations yet",
      "description": "Add a location manually or extract them from the script"
    },
    "selectLeft": "Select a location on the left to open the card.",
    "selectFromStrip": "Select a location above to open the card.",
    "createOrExtract": "Create or extract locations.",
    "actionsAria": "Location list actions",
    "floatingActionsMenuAria": "More location actions",
    "queued": "Queued…",
    "generate": "Generate location",
    "prompt": "Prompt",
    "versions": "Viewpoint versions",
    "correct": "Correct",
    "replaceView": "Replace {{view}}",
    "roomViewer": {
      "open": "3D view",
      "title": "{{name}} · 3D room",
      "titleWithVariant": "{{name}} · {{variant}} · 3D room",
      "description": "Cardinal walls of the location. Empty viewpoints can be generated.",
      "close": "Close",
      "wallsTitle": "Viewpoints (16:9)",
      "createViewpoint": "Create viewpoint",
      "createViewpointNeedImages": "Generate at least one image in the view first",
      "creatingViewpoint": "Saving…",
      "viewpointsTitle": "Viewpoints",
      "viewpointsEmpty": "No additional viewpoints yet — capture one from the 3D view.",
      "applyViewpoint": "Apply camera",
      "renameViewpointTitle": "Rename viewpoint",
      "renameViewpointNameLabel": "Name",
      "cameraTitle": "Camera",
      "hud": "x {{x}}  y {{y}}  z {{z}}   {{yaw}}°   fov {{fov}}°",
      "shape": "Shape",
      "shapeCube": "Cube",
      "shapeCylinder": "Cylinder",
      "shapeSphere": "Sphere",
      "generatePanorama": "Generate panorama",
      "regeneratePanorama": "Regenerate panorama",
      "fov": "FOV",
      "height": "Height",
      "minimapHint": "click map to move",
      "controlsHint": "LMB — look\nW A S D / arrows — move\nShift — orbit like the view cube\nR / F — height\nwheel — zoom",
      "controlsHintSphere": "LMB — look\nwheel — zoom\n(walk disabled in sphere mode)",
      "preset": {
        "center": "Center",
        "nw": "NW corner",
        "ne": "NE corner",
        "sw": "SW corner",
        "se": "SE corner"
      }
    },
    "scene3d": {
      "open": "Open 3D scene",
      "previzesSectionTitle": "3D Scenes",
      "addScene": "Add 3D scene",
      "previzesEmpty": "No 3D scenes for this location yet.",
      "previzesLoading": "Loading…",
      "previzesLoadMore": "Load more",
      "previzEmpty": "No video yet",
      "tileEmpty": "No cover yet",
      "title": "{{name}} · 3D scene",
      "description": "Place primitives, heroes and props.",
      "close": "Close",
      "backToLocations": "Back to locations",
      "backToScenes3d": "Back to 3D scenes",
      "flyQrLabel": "Open fly mode on mobile",
      "viewQrLabel": "Camera view on mobile",
      "characters": "Characters",
      "props": "Props",
      "heroes": "Add objects",
      "add": "Add",
      "pickerTitle": "Add to scene",
      "pickerSubtitle": "Project characters, props, and objects.",
      "missing": "missing",
      "defaultSize": "default size",
      "reset": "Clear scene",
      "resetConfirm": "Clear the 3D scene contents?\nThis cannot be undone.",
      "removeObject": "Remove object",
      "objectColor": "Object color",
      "objectColorClear": "Clear object color",
      "heroFigure": "Hero figure",
      "objectPath": "Object path",
      "figures": {
        "humanoid": "Human",
        "quadruped": "Animal on four legs",
        "biped": "Animal on two legs"
      },
      "record": "Record (Shift+Space)",
      "stopRecord": "Stop recording (Shift+Space)",
      "recordCancel": "Cancel recording (Shift+Space)",
      "recordArmedHint": "Start moving and recording will begin",
      "trajectory": {
        "mode": "Camera path (T)",
        "draw": "Draw",
        "drawHint": "Draw the trajectory (on/off)",
        "goToPathStart": "Start",
        "goToPathStartHint": "Go to the start of the trajectory",
        "lookAlong": "Along",
        "lookObserve": "Watch",
        "lookRecorded": "Look",
        "lookRecordToggle": "Look recording",
        "recordLook": "Record look",
        "rerecordLook": "Record look again",
        "rewriteLookHint": "Press Space or click the scene, and recording will start",
        "replaceLook": "Replace the recorded look?",
        "stopLook": "Stop look",
        "pickObject": "Pick object",
        "pickTarget": "pick a target",
        "pickTargetAction": "Pick a target",
        "pickPrompt": "Click an object… (Esc — cancel)",
        "targetLine": "Target: {{name}} — change",
        "noLook": "no recording",
        "lookRecordingLabel": "Recording look",
        "figure": "Figure",
        "needPath": "Draw a trajectory first",
        "stopPlayback": "Stop the playback",
        "smooth": "Smooth",
        "lookThrough": "Camera view",
        "freeView": "Free view",
        "clear": "Delete trajectory",
        "clearCamera": "Delete camera trajectory",
        "clearCameraConfirm": "Delete the camera trajectory?\nThis cannot be undone.",
        "clearObject": "Delete object trajectory",
        "clearObjectConfirm": "Delete the object trajectory?\nThis cannot be undone.",
        "done": "Done"
      },
      "play": "Play (Space)",
      "stopPlay": "Stop (Space)",
      "saveStart": "Save as start",
      "goToStart": "To start",
      "captureViewpoint": "Capture viewpoint",
      "captureHintViewpoint": "Take a viewpoint photo",
      "captureHintFlight": "Record a flythrough",
      "viewpointName": "Viewpoint",
      "viewpointSaved": "Viewpoint saved",
      "overlay": {
        "recordStart": "Start recording",
        "recordStop": "Stop recording",
        "recordSave": "Save recording",
        "keyW": "W — forward",
        "keyS": "S — back",
        "keyA": "A — left",
        "keyD": "D — right",
        "keyR": "R — up",
        "keyF": "F — down"
      },
      "saveScene": "Save scene",
      "sceneSaved": "Scene saved",
      "closeUnsavedPrevizTitle": "Previz not saved",
      "closeUnsavedPrevizMessage": "There is a recorded flythrough that has not been saved as a previz yet. Save previz?",
      "closeUnsavedPrevizSave": "Save",
      "closeUnsavedPrevizDiscard": "Don't save",
      "undo": "Undo",
      "redo": "Redo",
      "history": "History",
      "historyEmpty": "No actions yet",
      "historyClear": "Clear",
      "historyActions": {
        "baseline": "Initial state",
        "raiseSectors": "Raise {{count}} sectors",
        "lowerSectors": "Lower {{count}} sectors",
        "shiftFacesOut": "Shift outward · {{count}}",
        "shiftFacesIn": "Shift inward · {{count}}",
        "light": "Light",
        "platform": "Platform",
        "objects": "Objects",
        "faceGenerate": "Generate wall",
        "faceUpload": "Upload wall",
        "faceLibrary": "Library wall",
        "faceClear": "Clear wall",
        "faceColor": "Wall color",
        "pathAddPoint": "Path point",
        "pathDeletePoint": "Delete point",
        "pathClear": "Clear path",
        "pathMovePoint": "Move point",
        "pathBend": "Bend",
        "pathLook": "Path look",
        "pathSmooth": "Smoothing",
        "pathDuration": "Duration",
        "pathSpeed": "Flythrough speed",
        "pathRecord": "Flight recording",
        "pathTrim": "Trim"
      },
      "startCameraSaved": "Start position saved",
      "startCameraMissing": "No start position saved yet",
      "liveSync": {
        "live": "Live",
        "following": "Following"
      },
      "speed": "Speed",
      "fov": "FOV",
      "fovControl": {
        "label": "Field of view",
        "degrees_one": "{{count}} degree",
        "degrees_other": "{{count}} degrees",
        "focalMm": "{{mm}} mm"
      },
      "controlsHelp": "Controls help",
      "createDialog": {
        "title": "New 3D scene",
        "create": "Create scene",
        "creating": "Creating…",
        "cancel": "Cancel",
        "location": "Location",
        "noLocation": "No location",
        "platform": "Platform",
        "walls": "Walls",
        "wallHeight": "Wall height",
        "wallPreset": {
          "none": "Platform only",
          "one": "One far wall",
          "farTwo": "Two far walls",
          "three": "Three walls",
          "box": "Four walls"
        }
      },
      "environment": {
        "theme": "Time of day",
        "themeLight": "Day",
        "themeDark": "Night",
        "themeToNight": "Switch to night",
        "themeToDay": "Switch to day",
        "themeSwitch": "Switch time of day",
        "skyMarkup": "Sky markup",
        "markupPlus": "Crosses",
        "markupDots": "Dots",
        "markupNone": "None"
      },
      "controlsHint": {
        "fly": "Fly:",
        "record": "Record:",
        "light": "Light:",
        "move": "move toward look",
        "lmb": "LMB",
        "orbit": "orbit",
        "faster": "turn the camera",
        "upDown": "up / down",
        "playStop": "play / stop path",
        "recordToggle": "start / stop recording",
        "trajectory": "Path:",
        "trajectoryToggle": "flythrough path mode",
        "captureViewpoint": "capture viewpoint",
        "lightDrag": "— height and plane",
        "lightShiftDrag": "closer / farther from camera"
      },
      "toolbarMore": "More",
      "controlsHintFly": "Fly: W A S D to move toward the cursor,\nR / F up/down, LMB + drag — orbit, LMB + drag + Shift — turn the camera.\nSpace — play/stop path.\nShift+Space — start/stop recording.\nLight: drag — height and plane; Shift+drag — closer/farther from the camera.",
      "deviceCamera": {
        "enable": "Phone camera",
        "disable": "Turn off phone camera",
        "leftStick": "Strafe stick",
        "rightStick": "Fly / turn stick",
        "doubleTapExit": "Double-tap to exit phone camera",
        "permissionDenied": "No access to device orientation. Allow it in browser settings.",
        "unsupported": "Device orientation is not available in this browser.",
        "notReady": "Scene is still loading. Tap again in a moment.",
        "tapToLook": "Tap to enable look"
      },
      "mode": {
        "orbit": "Orbit",
        "fly": "Fly"
      },
      "timeline": {
        "scrub": "Flythrough timeline",
        "trim": "Trim flythrough to selected range",
        "trimIn": "Range start",
        "trimOut": "Range end",
        "reset": "Clear flythrough",
        "resetConfirm": "Clear the recorded flythrough?\nThis cannot be undone.",
        "save": "Save previz",
        "saveToShot": "Use previz",
        "saving": "Saving previz…",
        "saved": "Previz saved, video is being prepared",
        "exportEmpty": "Could not record video — re-record the flythrough and save again.",
        "recTimer": "Recording: {{s}}s / {{max}}s",
        "speed": "Camera speed",
        "speedSplit": "Split",
        "speedPause": "Pause",
        "takes": "Flythrough takes",
        "takeName": "Take {{n}}",
        "newTake": "New take",
        "takesFull": "All flythrough slots are full. Delete a take to record a new one.",
        "renameTake": "Rename take",
        "renameTakeName": "Name",
        "deleteTake": "Delete take",
        "deleteTakeConfirm": "Delete take “{{name}}”?",
        "deleteTakeAction": "Delete",
        "overwriteTake": "Overwrite flythrough",
        "overwriteTakeConfirm": "This take already has a flythrough.\nThe new recording will replace it.",
        "speedPresets": {
          "uniform": "Steady",
          "accel": "Accelerate",
          "brake": "Brake",
          "smooth": "Smooth",
          "pause": "Pause"
        }
      },
      "viewPreset": {
        "top": "Top view",
        "front": "Front view",
        "back": "Back view",
        "left": "Left view",
        "right": "Right view",
        "iso": "Isometric"
      },
      "gizmo": {
        "move": "Move",
        "rotate": "Rotate",
        "scale": "Scale"
      },
      "groupObjects": "Group",
      "ungroupObjects": "Ungroup",
      "lightIntensity": "Light intensity",
      "primitive": {
        "box": "Box",
        "sphere": "Sphere",
        "cylinder": "Cylinder",
        "cone": "Cone",
        "plane": "Plane"
      }
    },
    "scenePlatform": {
      "title": "{{name}} · sector scene",
      "description": "Build a sector platform, extrude terrain, and assign images to faces.",
      "close": "Close",
      "sectorsX": "Sectors along X",
      "sectorsZ": "Sectors along Z",
      "unit": "Unit of measurement",
      "unitCm": "cm",
      "unitM": "m",
      "apply": "Save platform",
      "modePlatform": "Platform",
      "extrude": "Raise",
      "intrude": "Lower",
      "shiftOut": "Shift outward",
      "shiftIn": "Shift inward",
      "faceTitle": "Face",
      "faceEmpty": "No image on this face.",
      "upload": "Upload",
      "library": "Library",
      "libraryTarget": "Face",
      "clear": "Clear wall",
      "wallColor": "Wall color",
      "floorColor": "Floor color",
      "floorColorClear": "Clear floor color",
      "wallColorClear": "Clear wall color",
      "wallColorPresetGreen": "Green #00B140",
      "prompt": "Prompt for this wall",
      "generate": "Generate",
      "light": "Lighting position",
      "lightNorth": "North",
      "lightEast": "East",
      "lightSouth": "South",
      "lightWest": "West",
      "lightTop": "Top",
      "errors": {
        "sectors_x": "Sector count on X is out of range.",
        "sectors_z": "Sector count on Z is out of range.",
        "unit": "Unit must be cm or m.",
        "sector_size": "Sector size is out of range.",
        "platform_side": "Platform side is too long.",
        "height": "Sector height is out of range."
      }
    },
    "angles": {
      "stripTitle": "Angles",
      "allLink": "All viewpoints",
      "pickerTitle": "All viewpoints",
      "searchPlaceholder": "Search viewpoints…",
      "noResults": "No results",
      "additionalItem": "Additional viewpoint",
      "additionalItemIndexed": "Viewpoint {{index}}",
      "deleteViewpointConfirm": "Delete viewpoint “{{name}}”? This cannot be undone.",
      "sections": {
        "basic": "Basic",
        "additional": "Additional angles"
      }
    },
    "dropDialog": {
      "title": "Place image",
      "description": "Copy “{{from}}” onto “{{to}}”, or swap the two views.",
      "copy": "Copy",
      "swap": "Swap views",
      "cancel": "Cancel",
      "swapDisabled": "The target view has no image to swap."
    },
    "edit": "Edit",
    "editNameHint": "Click to rename",
    "delete": "Delete",
    "regenerate": "Regenerate",
    "uploadVersion": "Upload file",
    "reference": "Reference:",
    "model": "model",
    "configureStudio": "Configure in Studio",
    "lightboxTitle": "{{name}} · {{facing}}",
    "variantLightboxTitle": "{{name}} · \"{{variant}}\" · {{facing}}",
    "facing": {
      "north": "North",
      "east": "East",
      "south": "South",
      "west": "West",
      "northShort": "N",
      "eastShort": "E",
      "southShort": "S",
      "westShort": "W",
      "three_quarterShort": "3/4",
      "topviewShort": "Top",
      "hasRef": "{{facing}} · reference available",
      "noRef": "{{facing}} · no reference",
      "hasRefAria": "{{facing}}, reference uploaded",
      "noRefAria": "{{facing}}, no reference"
    },
    "viewCaption": "View: {{view}}",
    "views": {
      "three_quarter": "3/4",
      "topview": "Top view",
      "north": "North",
      "east": "East",
      "south": "South",
      "west": "West",
      "panorama": "Panorama"
    },
    "generateView": "Generate {{view}}",
    "regenerateView": "Regenerate {{view}}",
    "viewEmpty": "{{view}} not generated yet",
    "facingPrereq": {
      "needThreeQuarter": "Generate or upload 3/4 first",
      "needNorth": "Generate or upload North first",
      "needEastWest": "Generate or upload West and East first",
      "needGroundLevel": "Generate or upload 3/4 or North first",
      "needPanoramaBase": "Generate or upload North or 3/4 first"
    },
    "enlargeImage": "Enlarge image",
    "referenceAlt": "Reference: {{name}}",
    "noReferenceFacing": "No reference for this view · upload or generate",
    "fieldDescription": "Description",
    "fieldMood": "Mood",
    "fieldVisualTraits": "Visual details",
    "noDescriptions": "No descriptions yet. Open «Edit» to fill in.",
    "profilePlaceholder": "Describe the location. Insert attributes via @…",
    "variants": "Variants (time / weather)",
    "facingsTitle": "Angles",
    "addVariant": "Add variant",
    "noVariants": "No variants yet.",
    "defaultVariantBadge": "Base",
    "locationBase": "Location",
    "defaultVariantNoGenerate": "The base variant matches the location reference — generate from the location card above",
    "noRef": "no ref",
    "variantQueuedHint": "Generation already queued — track progress in «Jobs»",
    "variantNeedBaseHint": "Generate or upload base location reference first — it will be used for the variant",
    "variantGenerateHint": "Generate this variant reference from the base",
    "destroyBlocked": "Location is used in scenes or shots.",
    "deleteLocation": "Delete location «{{name}}»?",
    "deleteLocationConfirmTitle": "Delete location «{{name}}»?",
    "deleteLocationConfirmMessage": "The location card, variants, and related reference versions will be deleted. This cannot be undone.",
    "deleteLocationConfirmAction": "Delete",
    "deleteVariant": "Delete variant «{{name}}»? Shot links will reset to «base».",
    "deleteVariantConfirmTitle": "Delete variant «{{name}}»?",
    "deleteVariantConfirmMessage": "Shot links will reset to the base location reference. This cannot be undone.",
    "deleteVariantConfirmAction": "Delete",
    "newLocation": "New location",
    "editLocation": "Edit «{{name}}»",
    "newVariant": "New location variant",
    "editVariant": "Edit variant «{{name}}»",
    "variantAlt": "Variant {{name}}",
    "enlargeVariant": "Open enlarged image for selected facing",
    "enlargeVariantAria": "Enlarge variant «{{name}}» image",
    "generating": "generating",
    "queuedShort": "Queued…"
  },
  "projectExport": {
    "toolbarBtn": "Export project",
    "dialogTitle": "Export project",
    "hint": "Choose a format and start a background build. Progress is in the jobs queue; finished files appear in the list below. Kept for 3 days, max 10 exports per project (oldest are removed).",
    "formatLabel": "Format",
    "formatZip": "Zip archive with videos",
    "formatZipHint": "All shot video versions in folders.",
    "formatDavinci": "DaVinci Resolve",
    "formatDavinciHint": "Media bins per shot plus FCPXML timelines with active shots.",
    "formatBadgeZip": "Zip",
    "formatBadgeDavinci": "DaVinci",
    "start": "Start export",
    "download": "Download",
    "inProgress": "Building…",
    "progress": "{{percent}}%",
    "failed": "Build failed",
    "expired": "File deleted — retention period expired",
    "queuedToast": "Export started — progress is in the jobs queue.",
    "enqueueFailed": "Could not start export ({{status}}).",
    "fetchFailed": "Could not refresh export ({{status}})."
  },
  "team": {
    "headTitle": "Team",
    "add": "Add",
    "invite": "Invite",
    "searchPlaceholder": "Name or email",
    "moreActions": "Member actions",
    "invitationColumns": {
      "status": "Status",
      "sent": "Sent"
    },
    "footer": {
      "reset": "Clear search"
    },
    "empty": {
      "searchTitle": "Nobody matches the search."
    },
    "deactivated": "deactivated",
    "roleAria": "Project role: {{name}}",
    "remove": "Remove from project",
    "removeConfirmTitle": "Remove {{name}} from the project?",
    "removeConfirmBody": "{{name}} will lose access to “{{project}}” but stays a company member and on their other projects.\n\nTheir generations and edits stay in the project. You can bring them back with “Add”.",
    "removeConfirmBodyOwner": "{{name}} loses their role on “{{project}}” but keeps access to it as a company owner.\n\nTheir generations and edits stay in the project. You can give them a role again with “Add”.",
    "removeConfirmAction": "Remove from project",
    "invitationPending": "pending · until {{date}}",
    "invitationPendingNoDate": "pending",
    "invitationExpired": "expired {{date}}",
    "resend": "Send again",
    "revoke": "Revoke",
    "revokeConfirmWhole_one": "The whole invitation is revoked, including {{count}} other project.",
    "revokeConfirmWhole_other": "The whole invitation is revoked, including {{count}} other projects.",
    "emptyText": "You are the only one on this project. A colleague will join the company as a Member and get access to “{{project}}” right away.",
    "emptyInvite": "Invite a colleague",
    "addDialog": {
      "title": "Add to project",
      "description": "Members of {{company}} who are not on “{{project}}” yet.",
      "searchPlaceholder": "Name or email",
      "quotedName": "“{{name}}”",
      "inProject": "on {{name}}",
      "inProjects": "on {{names}}",
      "andMore": "and {{count}} more",
      "noProjects": "no projects",
      "nothingFound": "Nobody found",
      "alreadyInProject": "Already on the project: {{names}}.",
      "inviteLinkPrefix": "Can’t find someone? You can",
      "inviteLink": "invite someone new",
      "roleTitle": "Project role",
      "roleHint": "one for everyone selected",
      "selected": "Selected: {{count}}",
      "submit_one": "Add {{count}} member",
      "submit_other": "Add {{count}} members",
      "submitEmpty": "Add"
    },
    "groups": {
      "team": "Team",
      "owners": "Company owners",
      "invitations": "Invitations",
      "inactive": "Deactivated"
    },
    "generations": {
      "title": "Generations",
      "allForPerson": "All generations by this person →",
      "empty": "{{name}} has not generated anything in this project yet.",
      "emptyProject": "No generations yet. The feed fills up as soon as somebody runs a storyboard or a video.",
      "neverSeen": "Has never opened the project.",
      "retry": "Retry",
      "emptyForRange": "No generations in the selected period.",
      "resetRange": "Show all"
    },
    "stats": {
      "inProject": "In project",
      "activity": "Activity",
      "since": "since {{date}}",
      "invitedBy": "invited by {{name}}",
      "neverSeen": "never signed in",
      "spend30d": "spend over 30 days",
      "shareOfProject": "{{percent}}% of project spend",
      "perGeneration": "per generation",
      "total": "total",
      "countIn30d_one": "{{count}} over 30 days",
      "countIn30d_other": "{{count}} over 30 days",
      "generations30d": "generations over 30 days"
    },
    "memberCard": "Member card",
    "openInMembers": "Open member page →",
    "invitationNoRole": "No project role",
    "invitationExpiredShort": "expired",
    "invitationUntil": "until {{date}}",
    "invitationLastSent": "Last sent",
    "invitationProjects": "Other projects",
    "invitationOtherProjects_one": "+{{count}} more project",
    "invitationOtherProjects_other": "+{{count}} more projects",
    "invitationAfterAccept": "Generations appear once the invitation is accepted.",
    "archivedInvitationsHint": "The project is archived — invitations cannot be managed right now.",
    "overview": {
      "pickTitle": "Pick a teammate",
      "pickHint": "A teammate's card shows their activity, generations and spend over 30 days. While nobody is selected, the summary below covers the whole team.",
      "teamHeatmap": "Team activity over the year"
    }
  },
  "settings": {
    "headTitle": "Settings",
    "title": "Project settings",
    "duplicateTitle": "Duplicate project",
    "duplicateHint": "Copy runs in the background and transfers only existing objects and files without API generation calls.",
    "duplicateBtn": "Duplicate project",
    "duplicateQueuedToast": "Duplication started — progress is in the jobs queue.",
    "duplicateEnqueueFailed": "Could not start duplication ({{status}}).",
    "archiveTitle": "Archive project",
    "archiveScreenTitle": "Remove the project from the list",
    "archiveLead": "“{{name}}” will disappear from the projects page. The script, shots, media and team stay in place: archive only hides the project from the list and does not delete anything. There is no way in the interface to put it back.",
    "archivePointLink": "A direct link still opens the project.",
    "archivePointInvites": "Invitations cannot be sent to an archived project.",
    "archiveBtn": "Archive project",
    "archiveConfirmTitle": "Archive this project?",
    "archiveConfirmMsg": "The project will disappear from the projects page. Its data stays, and a direct link still opens it. There is no way in the interface to put it back on the list.",
    "archiveConfirmAction": "Archive",
    "companyAccessTitle": "Company access",
    "companyAccessHint": "Share the project with other companies.",
    "notShared": "Project is not shared with other companies yet.",
    "companyFallback": "Company #{{id}}",
    "accessContent": "Content",
    "accessView": "View only",
    "accessSettings": "Settings",
    "revoke": "Revoke",
    "company": "Company",
    "selectCompany": "Select company…",
    "shareCompanySearch": "Search company…",
    "shareCompanyEmpty": "No matches",
    "accessLevel": "Access level",
    "accessContentOption": "Content (no settings)",
    "accessContentHint": "Fill the project without settings access",
    "accessViewOption": "View only",
    "accessViewHint": "Read-only access",
    "accessSettingsOption": "Settings and content",
    "accessSettingsHint": "Employees can edit settings and content",
    "share": "Share",
    "duplicateDialogTitle": "Duplicate project",
    "duplicateDialogHint": "Choose source and copy scope. Assets are copied within ActiveStorage; external services are not called.",
    "sourceProject": "Source project",
    "copyName": "Copy name",
    "copyNamePlaceholder": "New copy",
    "copySuffix": "(copy)",
    "targetCompany": "Target company",
    "startCopy": "Start copy",
    "sectionsTitle": "Sections",
    "sectionsHint": "Select a block — fields on the right.",
    "navGroups": {
      "project": "Project",
      "manage": "Manage"
    },
    "cards": {
      "identity": "Name and type",
      "style": "Style",
      "frame": "Frame",
      "structure": "Structure",
      "billing": "Billing"
    },
    "tabs": {
      "story": "Original story",
      "storyHint": "logline · script",
      "general": "General settings",
      "generalHint": "name · format · style",
      "providers": "API models",
      "providersHint": "text · images · video · audio",
      "prompts": "System prompts",
      "promptsHint": "project overrides"
    },
    "storyHint": "Story text or logline. Used as the basis for season structure, script and prompt generation.",
    "openInScript": "Open in Script",
    "storyPlaceholder": "Series idea, tone, hook for vertical format…",
    "saveStory": "Save story",
    "name": "Name",
    "taskPrefix": "Prefix",
    "taskPrefixHint": "Task tickers look like {{example}}. 2–4 Latin letters, unique within the company.",
    "taskPrefixChangeTitle": "Change the task prefix?",
    "taskPrefixChangeMsg": "All task tickers in this project will change from {{from}} to {{to}}. Old links to tasks will stop working.",
    "taskPrefixChangeAction": "Change prefix",
    "genre": "Genre",
    "genrePlaceholder": "Select a genre…",
    "uncategorizedGroup": "Uncategorized",
    "narrativeTone": "Narrative tone",
    "tonePlaceholder": "Select a narrative tone…",
    "tone": "Tone",
    "medium": "Medium",
    "mediumPlaceholder": "Enter a style name for this project",
    "mediumModalHint": "If this medium is not in the catalog, a custom name will be used for this project only",
    "mediumSelectButton": "Choose visual medium",
    "mediumClearButton": "No style",
    "mediumModalTitle": "Choose visual medium",
    "mediumNoImage": "No preview",
    "mediumModalClose": "Close",
    "mediumPreviewSelect": "Select",
    "mediumPreviewZoom": "Enlarge preview",
    "mediumSaveButton": "Save",
    "mediumNoResults": "Nothing found",
    "deprecatedGenre": "Current value is outdated: «{{value}}». Save settings to update the genre.",
    "deprecatedTone": "Current value is outdated: «{{value}}». Save settings to update the narrative tone.",
    "deprecatedMedium": "Current value is outdated: «{{value}}». Save settings to update the visual medium.",
    "frameFormat": "Frame format",
    "frameFormatHint": "One format for the whole series: applies to all storyboard and video APIs and previews. Changing format affects new generations; existing frames keep their aspect ratio.",
    "videoOutputFps": "Output FPS",
    "videoOutputFpsHint": "Frame rate used when normalizing videos after generation or upload. Changing this affects new files; existing clips keep their stored frame rate.",
    "videoOutputFpsHintInherit": "Currently using Studio default ({{fps}} fps). Applied to normalization after generation or upload.",
    "videoOutputFpsDefaultFromStudio": "Default (from Studio) — {{fps}} fps",
    "videoOutputFpsOption": "{{fps}} fps",
    "projectType": "Project type",
    "projectTypeHint": "The type is set at creation and cannot be changed later.",
    "visualStyle": "Image style (character references & visuals)",
    "visualStyleHint": "Unified rendering technique for all image generation in the project.",
    "stylesEnabled": "Catalog styles",
    "stylesEnabledHint": "Genre, tone, and medium are injected into every generation. Turning this off keeps the selected values.",
    "seasons": "Seasons",
    "episodes": "Episodes",
    "secPerEpisode": "Sec/episode",
    "spendLimitLabel": "Project spending limit",
    "spendLimitTooltip": "The account is where the money is charged from. The limit is how much the project may spend per month from any account. Whichever runs out first stops generations.",
    "spendLimitNoneHint": "The project spends while there are funds on the account, room under the company limit and people's personal limits.",
    "spendLimitLine": "spent {{spent}} · left {{left}}",
    "spendLimitEditHint": "Edited in a separate window and saved at once; visible to and editable by company owners.",
    "duplicateSections": {
      "structure": "Structure",
      "directories": "Directories",
      "media": "Media",
      "description": "Description & original story",
      "settings": "Project settings",
      "settingsHint": "format, models, style, provider fields",
      "projectAssignments": "Project team",
      "projectAssignmentsHint": "member assignments to the project",
      "seasonsEpisodes": "Seasons & episodes",
      "seasonsEpisodesHint": "required base for scenes and shots",
      "scenes": "Scenes",
      "shots": "Shots",
      "shotPresets": "Shot presets",
      "shotPresetsHint": "hidden template and preview shots; depends on shots",
      "characters": "Characters",
      "characterAssets": "Character assets",
      "characterAssetsHint": "reference sheet, sheets, scale pose, media, versions",
      "characterVoices": "Character voices",
      "characterVoicesHint": "voices, design requests, previews",
      "characterLinks": "Character links to scenes, episodes and shots",
      "props": "Props",
      "propAssets": "Prop assets",
      "propAssetsHint": "reference sheet, inputs, reference versions, scale figure, prop scale sheets",
      "locations": "Locations",
      "locationVariants": "Location variants",
      "locationVariantsHint": "needed for shot links",
      "locationAssets": "Location assets",
      "locationAssetsHint": "reference sheet, inputs, angle versions, saved 3D viewpoints (shot angles need this)",
      "previzes": "Previzes",
      "previzesHint": "Flythrough videos of 3D scenes",
      "scene3ds": "3D scenes",
      "scene3dsHint": "3D scene layouts and viewpoints (required for previzes; location links copy only when Locations is on)",
      "cameraPresets": "Project camera presets",
      "coverImage": "Project cover",
      "referenceLibrary": "Canvas reference library",
      "sketchLibrary": "Sketch library",
      "libraryUploads": "Library uploads",
      "shotStoryboard": "Shot storyboard frames",
      "shotShootingBoard": "Shot shooting board frames",
      "shotVideo": "Shot videos",
      "shotReferenceInputs": "Shot reference inputs",
      "assemblyTimeline": "Assembly timeline",
      "assemblyTimelineHint": "tracks and clips, depends on shots",
      "animatic": "Episode animatic",
      "animaticHint": "off by default",
      "animaticSegments": "Animatic segments",
      "animaticSegmentsHint": "off by default",
      "generationSkills": "Skills",
      "generationSkillsHint": "Project skill library and assistant bindings"
    }
  },
  "studio": {
    "headTitle": "{{name}} — Studio",
    "episodeOptionLabel": "S{{season}}E{{episode}} — {{title}}",
    "errors": {
      "promptLoadFailed": "Could not load prompts",
      "versionsLoadFailed": "Could not load versions.",
      "networkUnavailable": "Network unavailable.",
      "activateVersionFailed": "Could not activate version.",
      "saveVersionMarkFailed": "Could not save version mark.",
      "saveFrameMarkFailed": "Could not save frame mark.",
      "extractClipTaskFailed": "Could not queue clip extraction task."
    },
    "toolbar": {
      "genre": "Genre:",
      "tone": "Tone:",
      "style": "Style:",
      "styles": "Styles:",
      "stylesDisabled": "No styles",
      "format": "Format:",
      "episode": "Episode",
      "jobs": "Jobs",
      "versions": "Versions"
    },
    "sidebar": {
      "versions": "Versions",
      "tasks": "Tasks",
      "assistant": "Assistant",
      "back": "Back to list",
      "shotHeading": "Shot {{number}}",
      "defaultTaskTitle": "Notes on Shot {{number}}",
      "insertTimecode": "Insert the current second of this shot",
      "loadFailed": "Could not load tasks.",
      "createFailed": "Could not create the task.",
      "createTask": "Create task"
    },
    "emptyEpisode": "This episode has no scenes or shots yet.",
    "viewer": {
      "video": "Video",
      "frame": "Frame",
      "source": "Source",
      "sourceTitleHasSegment": "Animatic fragment for this shot",
      "sourceTitleNoSegment": "No animatic segment",
      "extractProcessing": "Extracting segment…",
      "extractFailed": "Extraction failed",
      "retry": "Retry",
      "refClipNotExtracted": "Reference clip not extracted yet",
      "extractSegment": "Extract segment",
      "videoNotGenerated": "Video not generated yet",
      "frameNotGenerated": "Frame not generated yet",
      "storyboardVersions": "Storyboard versions",
      "videoVersions": "Video versions",
      "timelineAndMarks": "Fine cut",
      "noSavedVersions": "No saved versions",
      "versionPreview": "Version preview"
    },
    "promptRail": {
      "videoPrompt": "Video prompt",
      "framePrompt": "Frame prompt",
      "loading": "Loading…",
      "request": "Request",
      "promptNotSet": "Prompt not set",
      "image": "Image",
      "noReferenceData": "No character, location, or frame reference data."
    },
    "references": {
      "videoFrames": "Video frames",
      "firstFrame": "First frame",
      "lastFrame": "Last frame",
      "first": "First",
      "last": "Last",
      "framesNotExtracted": "Frames not extracted",
      "transitionFrames": "Transition frames",
      "left": "Left",
      "right": "Right"
    },
    "animaticSegment": {
      "downloadMp4": "Download MP4",
      "extractAndDownload": "Extract and download",
      "extractFailedRetry": "Extraction failed — try again.",
      "titlePrefix": "Animatic segment"
    },
    "shotAlt": "Shot {{label}}",
    "shotFallback": "Shot",
    "shotTitle": "{{label}} — {{summary}}"
  },
  "animatics": {
    "headTitle": "{{name}} — Animatics",
    "episodeOptionLabel": "S{{season}}E{{episode}} — {{title}}",
    "errors": {
      "createEpisodeFirst": "Create an episode first to upload an animatic.",
      "uploadFailed": "Upload failed.",
      "splitFailed": "Split failed.",
      "markersSplitTaskFailed": "Could not queue task.",
      "deleteSegmentFailed": "Could not delete segment.",
      "extractClipTaskFailed": "Could not queue clip extraction task.",
      "refClipPending": "Video clip not extracted yet — extraction task started. Retry after it completes.",
      "transcriptionStartFailed": "Could not start transcription.",
      "historyLoadFailed": "Could not load history",
      "createShotFailed": "Could not create shot.",
      "saveSceneFailed": "Could not save scene.",
      "markerAddFailed": "Failed to add marker.",
      "markerSaveFailed": "Failed to save marker.",
      "markerDeleteFailed": "Failed to delete marker.",
      "deleteSourceFailed": "Could not remove the file."
    },
    "confirmDeleteAnimatic": "Delete this episode's animatic reel? Files uploaded in shots will be kept.",
    "confirmSplitAllMarkers": "Save markers on the server, split segments in the background, then remove markers from the server after splitting?",
    "shortSegmentWarn": {
      "title": "Segment shorter than 2 seconds",
      "message": "One of the segments after the cut will be shorter than 2s. For Seedance and animatic shooting-board strips, that clip will be stretched to 2s by freezing the last frame. Continue?",
      "confirm": "Split"
    },
    "createShotModal": {
      "title": "Create shot from segment",
      "firstFrame": "First frame",
      "poster": "Poster",
      "lastFrame": "Last frame",
      "first": "First",
      "posterLabel": "Poster",
      "last": "Last",
      "segment": "Segment {{number}}",
      "scene": "Scene",
      "selectScene": "Select a scene…",
      "sceneOption": "Scene {{number}}",
      "insertAfterShot": "Insert after shot",
      "atBeginning": "At beginning",
      "shotOption": "Shot {{number}}",
      "shotTitle": "Shot title",
      "fromAnimatic": "From animatic",
      "videoDuration": "Video duration",
      "next": "Next",
      "location": "Location",
      "noLocation": "No location",
      "noLocationsInProject": "No locations in the project yet.",
      "characters": "Characters",
      "noCharactersInProject": "No characters in the project yet.",
      "storyboardPrompt": "Frame generation prompt",
      "storyboardPromptPlaceholder": "Describe the frame to generate…",
      "defaultPromptHint": "Can be left empty — the default prompt will be used.",
      "videoPrompt": "Video generation prompt",
      "videoPromptPlaceholder": "Describe the video to generate…",
      "create": "Create",
      "scenePrompt": "Scene {{number}}{{titleSuffix}}. Frame from animatic, segment {{segment}}.",
      "scenePromptUntitled": "Frame from animatic, segment {{segment}}."
    },
    "toolbar": {
      "format": "Format:",
      "episode": "Episode",
      "noEpisodes": "No episodes",
      "deleteAnimatic": "Delete animatic",
      "jobs": "Jobs",
      "versions": "Versions"
    },
    "upload": {
      "createEpisodeFirst": "Create an episode first to upload an animatic",
      "uploading": "Uploading…",
      "dropHint": "Drop animatic MP4 here or choose a file",
      "chooseFile": "Choose file"
    },
    "processing": {
      "title": "Preparing animatic",
      "extractingDuration": "Extracting video duration…",
      "failed": "Animatic processing failed",
      "deleteAndReupload": "Delete and upload again",
      "stepUpload": "Uploading file",
      "stepMetadata": "Video metadata",
      "stepFrames": "Timeline frames",
      "stepWebPreview": "Web preview for player",
      "webPreviewBadge": "Preparing web preview…",
      "preparingFramesHint": "Preparing segment frames…"
    },
    "segment": {
      "label": "Segment {{number}}",
      "splitTitle": "Place segment boundary at current position (S)",
      "split": "Split",
      "markerTitle": "Mark at current player position (M)",
      "marker": "Mark",
      "draftMarkersTitle": "Draft markers: {{count}}",
      "splitAllMarkers": "Split at all markers",
      "titlePrefix": "Segment",
      "sceneHeading": "Segment scene",
      "shotLinkHeading": "Link to shot",
      "unlink": "Unlink",
      "unlinkShot": "Unlink shot",
      "selectShot": "Select a shot…",
      "sceneGroup": "Scene {{number}}{{titleSuffix}}",
      "artifactsHeading": "Segment artifacts",
      "artifactsHint": "Extract from the segment start within the current video model's reference window (usually 15 s; Seedance 2.5 up to 30 s). One ffmpeg pass produces silent MP4, MP4 with audio, and MP3.",
      "extractArtifacts": "Extract artifacts",
      "silentMp4Label": "Silent MP4 (reference_video)",
      "downloadSilentMp4": "Download silent MP4",
      "audioMp4Label": "MP4 with audio (for preview)",
      "downloadAudioMp4": "Download MP4 with audio",
      "noAudioSourceHint": "Source has no audio track — skipped.",
      "mp3Label": "MP3 (reference_audio)",
      "downloadMp3": "Download MP3",
      "fileInterval": "Interval in file: {{start}} — {{end}}",
      "shootingBoardHeading": "Shooting board in shot (Seedance)",
      "shootingBoardHint": "Frames from the segment window (same as the MP4 reference, limited by the current video model's max), evenly spaced; strip shows first and last frame of the window.",
      "panelCount": "Panel count",
      "buildShootingBoardStrip": "Build strip into shot shooting board",
      "linkShotForStrip": "Link a shot to the segment to build the shooting-board strip.",
      "timelineTitle": "Segment {{number}}: {{start}} — {{end}}",
      "sceneShort": "S{{number}}",
      "selectOnTimeline": "Select a segment on the timeline"
    },
    "transcription": {
      "heading": "Segment transcription",
      "moreDetails": "More details",
      "processing": "Transcription in progress…",
      "pending": "Transcription queued…",
      "notStarted": "Transcription has not been started yet.",
      "regenerate": "Regenerate",
      "transcribe": "Transcribe",
      "history": "History",
      "detailTitle": "Segment transcription",
      "environment": "Environment",
      "locationMatch": "Location: {{name}}",
      "lighting": "Lighting: {{value}}",
      "characters": "Characters",
      "dialogue": "Dialogue",
      "props": "Props",
      "timing": "Timing",
      "animationIntent": "Directorial intent",
      "firstFrameNotes": "Notes for first frame",
      "videoNotes": "Notes for video",
      "uncertainty": "Uncertainty",
      "historyTitle": "Segment transcription history",
      "noRecords": "No records."
    },
    "actions": {
      "createShotFromSegment": "Create shot from segment",
      "deleteSegment": "Delete segment"
    },
    "deleteSegmentDialog": {
      "title": "Delete segment",
      "description": "Choose which neighbor to merge the time range with after deleting segment {{number}}.",
      "mergeLeft": "Merge with left",
      "mergeRight": "Merge with right",
      "segmentRef": " (seg. {{number}})"
    },
    "artifactRow": {
      "processing": "Extracting…",
      "failed": "Failed",
      "skipped": "Skipped",
      "failedGeneric": "Failed.",
      "awaitingExtract": "Awaiting extraction"
    },
    "bulk": {
      "title": "Bulk operations",
      "button": "Bulk",
      "close": "Close",
      "running": "Bulk processing…",
      "confirmTitle": "Start bulk operation?",
      "confirmPipelineIntro": "Will run:",
      "confirmExtract": "Extract artifacts: {{count}}",
      "confirmTranscribe": "Transcribe: {{count}}",
      "confirmCreateShots": "Create shots: {{count}}",
      "confirmRun": "Start",
      "errors": {
        "startFailed": "Could not start bulk operation.",
        "unknown": "Unknown error",
        "referenceClips": "Failed to extract reference clip",
        "transcription": "Transcription failed",
        "noScene": "No active scene",
        "shotCreate": "Failed to create shot"
      },
      "result": {
        "title": "Result",
        "success": "All segments processed successfully",
        "summary": "{{done}} of {{total}} done, {{failed}} failed",
        "allFailed": "No segments were processed",
        "errorsHeading": "Errors by segment",
        "segmentError": "Segment {{number}}: {{message}}",
        "moreErrors": "and {{count}} more",
        "dismiss": "Dismiss",
        "statusFailed": "Operation finished with errors",
        "statusPartial": "Operation completed with errors"
      },
      "blockers": {
        "noVideo": "Upload animatic video first",
        "noScene": "Create an active scene in the episode",
        "noFfmpeg": "ffmpeg is not available on the server"
      },
      "stats": {
        "total": "Total segments",
        "withShot": "With shot",
        "withoutShot": "Without shot",
        "withoutArtifacts": "Without artifacts",
        "withoutTranscription": "Without transcription"
      },
      "operations": {
        "extract": "Extract artifacts",
        "transcribe": "Transcribe",
        "createShots": "Create shots",
        "createShotsHint": "Includes extraction and transcription when needed"
      }
    },
    "sources": {
      "reel": "Reel:",
      "addFile": "Append a video file to the reel",
      "removeLast": "Remove the last file of the reel",
      "preparing": "Preparing",
      "failed": "Failed",
      "more": "{{count}} more"
    },
    "confirmDeleteSource": "Remove the last file of the reel along with its segments?"
  },
  "episodeTimeline": {
    "sceneLabel": "Scene {{number}}: {{title}}. More — full description.",
    "sceneUntitled": "untitled",
    "locationTitle": "Location: {{name}}",
    "scene": "Scene",
    "untitled": "Untitled",
    "noSceneDescription": "Scene description not set",
    "characters": "Characters",
    "noCharacters": "No characters",
    "moreCharacters": "{{count}} more characters: {{names}}",
    "locations": "Locations",
    "noLocations": "No locations",
    "moreLocations": "{{count}} more locations: {{names}}",
    "shotsWithFrame": "Shots with frame",
    "shotsWithVideo": "Shots with video",
    "createShot": "Create shot",
    "noShots": "No shots in this scene yet.",
    "emptySceneTitle": "No shots in this scene yet",
    "emptySceneHint": "Add an empty shot or break the scene down from the script.",
    "emptySceneHintLong": "Add an empty shot or ask the assistant to break the scene into shots from the script.",
    "addShot": "Add shot",
    "shotsFromScript": "From script",
    "shotsFromScriptTitle": "Ask the assistant to break the scene into shots from the script",
    "noScenes": "No scenes in this episode yet.",
    "addFirstScene": "Add first scene",
    "addScene": "Add scene",
    "shotsCount": "{{count}} shot(s)",
    "sceneDuration": "{{duration}}",
    "deleteScene": "Delete scene",
    "deleteSceneBlocked": "Remove all shots first",
    "deleteSceneConfirmTitle": "Delete scene?",
    "deleteSceneConfirmMessage": "Scene #{{number}} “{{title}}” will be permanently deleted.",
    "editSceneDescription": "Edit description",
    "sceneDescriptionPlaceholder": "Scene description…",
    "editNameHint": "Click to rename",
    "renameScene": "Rename scene"
  },
  "voicesSection": {
    "title": "Voices",
    "design": "Create",
    "designHint": "Create a voice from a text description",
    "remix": "Remix",
    "remixHint": "Variations of an existing voice",
    "remixSource": "Source voice",
    "ivc": "Clone",
    "ivcHint": "Instant voice cloning from audio files (IVC)",
    "import": "Import",
    "importHint": "Link an existing provider voice by voice_id",
    "importVoiceIdPlaceholder": "Provider voice_id",
    "importNamePlaceholder": "Name (optional — taken from provider if empty)",
    "minimaxIvcFilesHint": "Upload a clean voice sample (mp3/m4a/wav, 10 seconds–5 minutes, up to 20 MB).",
    "minimaxNeedNoiseReduction": "Noise reduction",
    "minimaxNeedVolumeNormalization": "Volume normalization",
    "minimaxLanguageBoost": "Language",
    "minimaxPreviewTextPlaceholder": "Optional preview phrase for clone demo",
    "minimaxPromptTextPlaceholder": "Optional prompt audio transcript",
    "minimaxPromptAudio": "Prompt audio",
    "minimaxPromptAudioHint": "A short speech sample (up to 8s). Helps capture speaking style and intonation when cloning.",
    "ivcFilesHint": "Upload 1–10 clean voice recordings (mp3/wav, at least 1 minute total).",
    "ivcDescriptionPlaceholder": "Optional description of the voice",
    "ivcRemoveBackgroundNoise": "Remove background noise",
    "ivcRemoveBackgroundNoiseHint": "Uses ElevenLabs audio isolation on samples. If there is no background noise, this can make quality worse.",
    "ivcLabelsTitle": "Labels (optional)",
    "ivcLabels": {
      "language": "Language (e.g. en)",
      "accent": "Accent (e.g. american)",
      "gender": "Gender (e.g. female)",
      "age": "Age (e.g. young)"
    },
    "uploadAudio": "Choose audio files",
    "uploadOrDrop": "Add or drop a file",
    "recordAudio": "Record audio",
    "recordOr": "or",
    "recordDurationHint": "{{min}}–{{max}} seconds",
    "recordCountdownHint": "Recording starts after a 3-second countdown — get ready.",
    "recordGo": "Go!",
    "recordUpTo": "Record up to {{max}} seconds",
    "recordingTooShort": "Recording is too short. Please record at least {{min}} seconds.",
    "micPermissionDenied": "Microphone access was denied. Allow access in browser settings and try again.",
    "stopRecording": "Stop recording",
    "cancelRecording": "Cancel recording",
    "removeFile": "Remove file",
    "promptPlaceholder": "Describe the voice: gender, age, timbre, accent, speaking style…",
    "promptPlaceholderRemix": "Describe the changes: higher pitch, warmer tone, slower pace…",
    "promptMinLength": "At least {{min}} characters",
    "previewTextLabel": "Preview phrase",
    "previewTextPlaceholder": "Same text for all candidates",
    "previewTextMinLength": "At least {{min}} characters",
    "defaultPreviewText": "The quick brown fox jumps over the lazy dog, then rests in the warm sun while birds sing softly in the trees nearby.",
    "namePlaceholder": "Voice name",
    "nameMissing": "Enter a voice name before picking a preview",
    "generatePreviews": "Generate",
    "clone": "Clone",
    "cancel": "Cancel",
    "jobFailed": "Voice generation failed",
    "previewsTitle": "Previews — pick the one you like",
    "pick": "Pick",
    "pickName": "New voice name:",
    "loading": "Loading voices…",
    "empty": "No voices yet. Create one via Design, Remix, Cloning, Import, or pick from the library.",
    "active": "Primary",
    "makeActive": "Make primary",
    "doubleClickActivate": "Double-click to make primary",
    "copyVoiceId": "Copy voice id",
    "voiceIdCopied": "Voice id copied",
    "voiceIdCopyFailed": "Failed to copy voice id",
    "renameEdit": "Rename voice",
    "renameSave": "Save name",
    "renameCancel": "Cancel",
    "delete": "Delete voice",
    "deleteConfirm": "Delete voice “{{name}}”?",
    "showDesignParams": "Show parameters",
    "designParamsTitle": "Design params",
    "actionsMenu": "Voice actions",
    "downloadPreview": "Download audio",
    "regeneratePreview": "Change preview",
    "regeneratePreviewTitle": "Voice preview",
    "regeneratePreviewSubmit": "Generate",
    "regeneratePreviewTextMissing": "Enter preview text",
    "regeneratePreviewTextTooLong": "Preview phrase must be at most {{max}} characters",
    "advancedTitle": "Advanced parameters",
    "advanced": {
      "loudness": "Loudness",
      "guidanceScale": "Guidance scale",
      "quality": "Quality",
      "seed": "Seed",
      "shouldEnhance": "Enhance description",
      "autoGenerateText": "Auto-generate preview text",
      "promptStrength": "Prompt strength",
      "referenceAudio": "Reference audio",
      "chooseAudio": "Choose audio file",
      "optional": "Optional"
    },
    "advancedHints": {
      "loudness": "Controls the volume level of the generated voice. −1 is quietest, 1 is loudest, 0 corresponds to roughly −24 LUFS.",
      "guidanceScale": "Controls how closely the AI follows the prompt. Lower numbers give the AI more freedom to be creative, while higher numbers force it to stick more to the prompt. High numbers can cause voice to sound artificial or robotic. We recommend to use longer, more detailed prompts at lower Guidance Scale.",
      "quality": "Higher quality results in better voice output but less variety. Allowed range: −1–1.",
      "seed": "Integer that controls the voice generation. Same seed with same inputs produces same voice. Allowed range: 0–2147483647.",
      "shouldEnhance": "Whether to enhance the voice description using AI to add more detail and improve voice generation quality. When enabled, the system will automatically expand simple prompts into more detailed voice descriptions.",
      "autoGenerateText": "Whether to automatically generate a text suitable for the voice description.",
      "promptStrength": "Balance of prompt versus reference audio. 0 — almost no prompt influence, 1 — almost no reference influence. Only with eleven_ttv_v3 and reference audio (design) or when remixing an existing voice.",
      "referenceAudio": "Reference audio for voice generation. Enables prompt strength. Only with the eleven_ttv_v3 model."
    },
    "method": {
      "design": "create",
      "remix": "remix",
      "ivc": "clone",
      "import": "import",
      "library": "library"
    },
    "library": "From library",
    "libraryHint": "Pick a ready-made voice from the provider library",
    "libraryPickHint": "The voice is added instantly — no generation, no charge.",
    "libraryPickPlaceholder": "Pick a voice…",
    "libraryOf": "{{provider}} library",
    "libraryAdded": "Voice “{{name}}” added from the library.",
    "defaultVoice": "Default voice",
    "defaultVoiceHint": "Until the character has its own voice, narration uses this one.",
    "remixElevenlabsOnly": "Remix is available for ElevenLabs only",
    "minimaxCloneExpiryHint": "MiniMax removes unused voice clones — use the voice from time to time so it is not dropped."
  },
  "agent": {
    "title": "Project assistant",
    "scene3dTitle": "3D scenes assistant",
    "platformTitle": "Platform assistant",
    "shotContext": "shot {{label}}",
    "shotContextStripAria": "References for the selected shot",
    "generateFrameShort": "Frame",
    "generateVideoShort": "Video",
    "clearShotSelection": "Back to storyboard assistant",
    "selectedShotChip": "Shot {{label}}",
    "placeholder": "Ask the assistant…",
    "attachImage": "Attach an image or video",
    "attachFromComputer": "Upload",
    "attachFromLibrary": "From the library",
    "attach": "Attach",
    "dropOverlay": "Drop to attach",
    "imageRemove": "Remove attachment",
    "imageTooLarge": "Image is larger than 20 MB",
    "videoTooLarge": "Video is larger than 100 MB",
    "imageBadType": "Use a JPEG, PNG, WebP, GIF, MP4, WebM, or MOV",
    "imageLimit": "At most 10 files can be attached",
    "videoLimit": "At most 2 videos can be attached",
    "imageFailed": "Could not analyze the attachment. Try again later.",
    "imageDraftQuota": "The browser is out of storage — this image will disappear after a refresh.",
    "imageOnlyQueued": "Image",
    "videoOnlyQueued": "Video",
    "attachmentOnlyQueued": "Attachment",
    "videoPreview": "Video",
    "readOnlyHint": "View-only access — you can read the chat, but not send messages.",
    "typing": "Agent is typing…",
    "thinking": "Thinking…",
    "thinkingPhrases": [
      "Thinking…",
      "Looking at project context…",
      "Checking the script…",
      "Working out a plan…",
      "Reviewing nearby shots…",
      "Putting the reply together…",
      "One more second…",
      "Checking the details…"
    ],
    "workingTool": "Agent is calling a tool…",
    "toolStatus": {
      "improve_prompt": "Updating the shot prompt",
      "update_shot_duration": "Updating shot duration",
      "update_shot_characters": "Updating the shot cast",
      "update_shot_location": "Updating the shot location",
      "create_next_shot": "Creating the next shot",
      "create_shots_batch": "Creating shots",
      "create_transition_shot": "Creating a transition shot",
      "create_scene": "Creating a scene",
      "handoff_to_assistant": "Opening the specialist assistant",
      "analyze_images": "Looking at the attachment",
      "attach_task_file": "Attaching a task file as a reference",
      "regenerate_keyframe": "Preparing keyframe regeneration",
      "regenerate_video": "Preparing video regeneration",
      "generate_project_cover": "Preparing project cover generation",
      "create_character": "Creating a character",
      "update_character": "Updating the character",
      "create_location": "Creating a location",
      "update_location": "Updating the location",
      "create_prop": "Creating a prop",
      "update_prop": "Updating the prop",
      "get_scene3d": "Loading the 3D scene",
      "create_scene3d": "Creating a 3D scene",
      "update_scene3d": "Updating the 3D scene",
      "update_scene3d_state": "Updating the 3D scene layout",
      "delete_scene3d": "Deleting the 3D scene",
      "place_scene3d_object": "Placing an object in the 3D scene",
      "place_scene3d_group": "Building an object from primitives",
      "update_scene3d_object": "Moving an object in the 3D scene",
      "remove_scene3d_object": "Removing an object from the 3D scene",
      "set_scene3d_face_color": "Painting a 3D scene face",
      "clear_scene3d_face": "Clearing a 3D scene face",
      "generate_scene3d_face": "Preparing a face material",
      "set_scene3d_camera_path": "Recording a camera path",
      "update_canvas_prompt": "Updating the canvas prompt",
      "update_generation_skill": "Updating the skill",
      "propose_episode_script": "Drafting a script version"
    },
    "expand": "Expand",
    "collapse": "Collapse",
    "execute": "Run",
    "cancel": "Cancel",
    "stop": "Stop",
    "stopping": "Stopping…",
    "error": "Agent error",
    "interrupted": "The run was interrupted. The reply so far was kept — you can continue.",
    "internalError": "Internal agent error. You can continue.",
    "networkError": "Could not reach the AI provider. Check your network or VPN, then try again.",
    "networkRetryIn": "Retrying in {{seconds}}s",
    "busy": "The agent is already processing a request",
    "rateLimited": "The agent service is busy. Wait a moment and send the message again.",
    "queueConfirmTitle": "Send next?",
    "queueConfirmMessage": "The agent is still answering. Send this as the next request when it finishes?",
    "queueReplaceTitle": "Replace the queued request?",
    "queueReplaceMessage": "A next request is already queued. Replace it with this text?",
    "queueConfirm": "Send next",
    "queueReplace": "Replace",
    "queuedNext": "Next: {{text}}",
    "queuedClear": "Remove from queue",
    "retry": "Retry",
    "silentRetryHint": "Retry the last turn without adding a new message",
    "editMessage": "Edit",
    "editingBanner": "Editing message",
    "editConfirmTitle": "Resend this message?",
    "editConfirmMessage": "Later agent replies will be deleted, and the request will run again.",
    "editConfirm": "Resend",
    "editCancel": "Cancel edit",
    "charactersUpdated": "Shot cast updated",
    "locationUpdated": "Shot location updated",
    "continue": "Continue",
    "continuePhrase": "Continue from where you left off",
    "loadError": "Failed to load history",
    "skillsPicker": "Attach skill",
    "skillsEmpty": "No skills left to attach",
    "skillsNothingFound": "No matching skills",
    "confirmError": "Failed to confirm action",
    "quickImprove": "Improve this shot prompt",
    "quickKeyframe": "Regenerate keyframe",
    "quickVideo": "Regenerate video",
    "quickNextShot": "Create next shot",
    "quickNextShotByScript": "Create next shot from the script",
    "quickCreateCharacter": "Create a character",
    "quickUpdateCharacterProfile": "Update character profile",
    "quickExtractCharacters": "Extract characters from the script: create or update heroes with full profiles (role, short description, personality, appearance, visual details)",
    "quickExtractCharactersLabel": "Extract from script",
    "quickExtractCharactersFromScriptLabel": "Extract characters",
    "quickGenerateCharacterReference": "Generate reference",
    "quickGenerateCharacterSheet": "Character sheet",
    "quickGenerateCharacterEmotionSheet": "Emotion sheet",
    "quickGenerateCharacterPortrait": "Portrait",
    "quickGenerateCharacterScalePose": "Scale pose",
    "quickGenerateCharacterMedia": "Video media",
    "quickRegisterSeedanceAvatar": "Seedance",
    "quickCreateLocation": "Create a location",
    "quickCreateScene3d": "Create a 3D scene",
    "quickDescribeScene3d": "What is in this scene",
    "quickPlaceScene3dHero": "Place a hero",
    "quickPaintScene3dFace": "Paint the selected face",
    "quickUpdateLocationProfile": "Update location profile",
    "quickExtractLocations": "Extract locations from the script: create or update places with full profiles (description, mood, visual traits)",
    "quickExtractLocationsLabel": "Extract from script",
    "quickExtractLocationsFromScriptLabel": "Extract locations",
    "quickGenerateLocationReference": "Generate reference",
    "quickCreateProp": "Create a prop",
    "quickUpdatePropProfile": "Update prop profile",
    "quickExtractProps": "Extract props from the script",
    "quickShotsFromScript": "Create scenes and shots from the current script text",
    "quickSummarizeScript": "Summarize the current script",
    "quickGeneratePropReference": "Reference",
    "quickGeneratePropFrontView": "Front view",
    "quickCanvasImprove": "Improve the prompt",
    "quickCanvasVideo": "Switch to video",
    "quickCanvasGenerate": "Generate",
    "updatingPrompt": "Updating prompt…",
    "promptUpdated": "Prompt updated",
    "savedPrompt": {
      "image": "Frame",
      "video": "Video",
      "shootingBoard": "Shooting board",
      "prompt": "Prompt",
      "copy": "Copy prompt",
      "copied": "Prompt copied",
      "copyFailed": "Could not copy"
    },
    "durationUpdated": "Shot duration: {{sec}}s",
    "videoReferencesUpdated": "Shot references updated",
    "startingAction": "Starting…",
    "actionStarted": "Generation started",
    "handoff": {
      "surface": {
        "characters": "Characters assistant",
        "locations": "Locations assistant",
        "props": "Props assistant",
        "shot": "Shot assistant",
        "script": "Script assistant",
        "tasks": "Tasks"
      },
      "status": {
        "running": "working",
        "done": "done",
        "failed": "failed"
      },
      "tooltip": "{{surface}} · {{status}}",
      "tooltipWithTask": "{{surface}} · {{status}}: {{task}}"
    },
    "untitledProject": "Untitled project",
    "emptyTitle": "Chat for {{project}}",
    "emptyShot": "Shot {{label}}",
    "emptyHint": "The conversation hasn’t started yet",
    "dock": {
      "profile": "Profile",
      "prompt": "Prompt",
      "assistant": "Assistant",
      "dirtyAria": "Unseen changes"
    },
    "quickUpdateSkillBody": "Rewrite / improve the skill body",
    "quickSimplifySkill": "Make the skill body shorter and clearer",
    "quickClarifySkill": "Clarify the instructions in the skill text",
    "quickExplainSkill": "What does this skill do?",
    "quickFindSkillContradictions": "Are there contradictions in the text?",
    "quickListProjects": "Which projects are in progress right now?",
    "quickCompanyBalance": "What is the studio balance?",
    "quickExplainSections": "Explain what the sections inside a project are for",
    "quickCreateProject": "Create a new project: ",
    "quickCreateProjectLabel": "Create project",
    "emptyCompanyTitle": "Studio assistant for \"{{company}}\"",
    "emptyCompanyHint": "Ask about projects, team, balance, or ask to create a project",
    "quickScriptFromSynopsis": "Write this episode's screenplay from its synopsis and save it as a draft",
    "quickScriptFromSynopsisLabel": "Script from synopsis",
    "quickFitScriptDuration": "Fit the episode screenplay to its target duration (1 page ≈ 1 minute) and save it as a draft",
    "quickFitScriptDurationLabel": "Fit to runtime"
  },
  "scenes3dPage": {
    "headTitle": "3D Scenes",
    "title": "3D Scenes",
    "add": "Add 3D scene",
    "defaultName": "Scene",
    "unlocated": "No location",
    "locationSceneCount_one": "{{count}} scene",
    "locationSceneCount_other": "{{count}} scenes",
    "rename": "Rename 3D scene",
    "editTitle": "Edit 3D scene",
    "renameNameLabel": "Name",
    "delete": "Delete 3D scene",
    "deleteConfirm": "Delete",
    "deleteFailed": "Could not delete the 3D scene.",
    "deleteWarning": "Delete 3D scene “{{name}}”?",
    "assignLocation": "Assign location",
    "assignLocationTitle": "Assign location",
    "assignLocationSave": "Save",
    "assignLocationFailed": "Could not update the location.",
    "unassignLocation": "Unlink from location",
    "unassignLocationTitle": "Unlink from location",
    "unassignLocationConfirm": "Unlink",
    "unassignLocationWarning": "Unlink scene “{{name}}” from location “{{location}}”?",
    "unassignLocationFailed": "Could not unlink the location.",
    "empty": {
      "title": "No 3D scenes yet",
      "description": "Create a scene for layout, viewpoints, and flythrough videos."
    },
    "viewpoints": {
      "title": "Viewpoints",
      "itemIndexed": "Viewpoint {{index}}",
      "delete": "Delete viewpoint",
      "deleteConfirm": "Delete viewpoint “{{name}}”? This cannot be undone."
    },
    "media": {
      "tab": "Viewpoints",
      "previzes": "Previzes",
      "previzesEmpty": "No previzes yet",
      "viewpointsEmpty": "No viewpoints yet",
      "loading": "Loading…",
      "viewpointCount": "Viewpoints",
      "previzCount": "Previzes"
    },
    "objects": {
      "tab": "Objects",
      "empty": "No objects in this scene yet",
      "showPath": "Show path"
    },
    "chats": {
      "shared": "Shared",
      "location": "Location",
      "scene": "Scene"
    }
  }
}
